// Generated from /Users/fabien/Downloads/fatf-ubo-guidance-full_3.html.
// Review extracted text before relying on it for legal interpretation.
const fatfBeneficialOwnership_2024 = {
  "id": "fatf-beneficial-ownership-2024",
  "title": "FATF Beneficial Ownership",
  "legalName": "Guidance for a Risk-Based Approach: Beneficial Ownership and Transparency of Legal Arrangements",
  "sourceFile": "FATF UBOs.pdf",
  "readerStyle": "guideline",
  "intro": "FATF Guidance - March 2024\nGuidance on Beneficial Ownership and Transparency of Legal Arrangements\nFATF guidance on implementing Recommendation 25.",
  "chapters": [
    {
      "chapter": "FATF Guidance",
      "title": "Beneficial Ownership and Transparency of Legal Arrangements",
      "articles": [
        {
          "number": "Abbreviations and Acronyms",
          "label": "Abbreviations and Acronyms",
          "title": "Abbreviations and Acronyms",
          "hideLabel": true,
          "body": "",
          "blocks": [
            {
              "id": "glossary-table--0",
              "type": "glossaryTable",
              "text": "AML/CFT Anti-money laundering and countering the financing of terrorism CDD Customer due diligence DNFBP Designated Non-Financial Business or Profession FATF Financial Action Task Force FI Financial institution FIU Financial intelligence unit INR Interpretive Note to Recommendation LEA Law enforcement agency ML Money laundering OECD Organisation for Economic Co-operation and Development PEP Politically exposed person STR Suspicious transaction reports TCSPs Trust and company service providers TF Terrorist financing",
              "rows": [
                {
                  "term": "AML/CFT",
                  "definition": "Anti-money laundering and countering the financing of terrorism"
                },
                {
                  "term": "CDD",
                  "definition": "Customer due diligence"
                },
                {
                  "term": "DNFBP",
                  "definition": "Designated Non-Financial Business or Profession"
                },
                {
                  "term": "FATF",
                  "definition": "Financial Action Task Force"
                },
                {
                  "term": "FI",
                  "definition": "Financial institution"
                },
                {
                  "term": "FIU",
                  "definition": "Financial intelligence unit"
                },
                {
                  "term": "INR",
                  "definition": "Interpretive Note to Recommendation"
                },
                {
                  "term": "LEA",
                  "definition": "Law enforcement agency"
                },
                {
                  "term": "ML",
                  "definition": "Money laundering"
                },
                {
                  "term": "OECD",
                  "definition": "Organisation for Economic Co-operation and Development"
                },
                {
                  "term": "PEP",
                  "definition": "Politically exposed person"
                },
                {
                  "term": "STR",
                  "definition": "Suspicious transaction reports"
                },
                {
                  "term": "TCSPs",
                  "definition": "Trust and company service providers"
                },
                {
                  "term": "TF",
                  "definition": "Terrorist financing"
                }
              ],
              "splitDefinitions": false
            }
          ]
        },
        {
          "number": "1",
          "label": "Section 1",
          "title": "Introduction",
          "hideLabel": false,
          "body": "",
          "blocks": [
            {
              "id": "clause-1-0",
              "type": "clause",
              "marker": "1.",
              "level": "main",
              "text": "Express 1 trusts and similar legal arrangements are generally formed for essential and legitimate purposes. However, to prevent cases where these legal arrangements may be abused by criminals that manage to circumvent anti-money laundering and counter-terrorist financing (AML/CFT) measures, the ability adequately and effectively identify the beneficial owners of these arrangements is key.",
              "children": []
            },
            {
              "id": "clause-2-1",
              "type": "clause",
              "marker": "2.",
              "level": "main",
              "text": "Countries should assess the money laundering and terrorist financing (ML/TF) risks of misuse of legal arrangements and take preventive measures. In particular, countries should ensure that there is adequate, accurate, and up-to-date information on express trusts and other similar legal arrangements. This includes information on the settlor(s), trustee(s), protector(s) and beneficiary(ies), or class(es) of beneficiaries, and any other person exercising ultimate effective control, that can be obtained or accessed efficiently and in a timely manner by competent authorities. Countries should consider facilitating access to beneficial ownership and control information by financial institutions (FIs) and Designated Non-Financial Businesses and Professions (DNFBPs) that are undertaking the requirements set out in Recommendation 10 (R.10) and Recommendation 22 (R.22).",
              "children": []
            },
            {
              "id": "clause-3-2",
              "type": "clause",
              "marker": "3.",
              "level": "main",
              "text": "This Guidance on Recommendation 25 (R.25) complements previous FATF work on strengthening the transparency of legal persons, by focusing on transparency requirements applicable to “legal arrangements”, which refers to express trusts or other similar legal arrangements. 2 It is important to bear in mind that trusts are not a type of legal entity or corporate vehicle but a relationship between the principal parties to such arrangement.",
              "children": []
            },
            {
              "id": "clause-4-3",
              "type": "clause",
              "marker": "4.",
              "level": "main",
              "text": "This Guidance is aimed at all stakeholders from public and private sectors that regulate, supervise, enforce, form, manage or administer trusts or similar legal arrangements. It focuses on R.25 requirements and addresses the trust-specific features and related AML/CFT transparency obligations. It complements the Guidance published on Recommendation 24 (R.24) in view of certain overlapping elements and aims to assist in the implementation of the requirements of R.25, adopted in February 2023. Guidance on R.24 and R.25 should be read in parallel as equally informing countries’ approaches to the implementation of the FATF Standards on beneficial ownership.",
              "children": []
            },
            {
              "id": "clause-5-4",
              "type": "clause",
              "marker": "5.",
              "level": "main",
              "text": "This Guidance is non-binding and does not override the purview of national authorities. It is intended to complement existing FATF guidance and other ongoing work by building upon the available research, including relevant FATF typologies reports, and the experiences of countries. It also takes into account work being undertaken by other international bodies, which are focusing on ensuring transparency of beneficial ownership information.",
              "children": []
            }
          ]
        },
        {
          "number": "2",
          "label": "Section 2",
          "title": "Scope of R.25: Trusts and other similar legal arrangements",
          "hideLabel": false,
          "body": "",
          "blocks": [
            {
              "id": "clause-6-0",
              "type": "clause",
              "marker": "6.",
              "level": "main",
              "text": "The FATF strengthened its Recommendation 24 and Recommendation 25 in March 2022 and February 2023 respectively. In March 2023, the FATF published an updated Guidance on beneficial ownership of legal persons to assist the implementation of the R.24 requirements. The Guidance on R.24 includes non- binding advice on how to assess and mitigate relevant ML/TF risks for legal persons and ensure accurate and adequate information is accessible in a timely manner. It also provides examples of relevant mechanisms to identify and verify the beneficial ownership information by competent authorities to ensure its accuracy. The Guidance additionally includes insights on proportionate, dissuasive, and effective sanctions and how these may best be applied to breaches of compliance with beneficial ownership requirements.",
              "children": []
            },
            {
              "id": "clause-7-1",
              "type": "clause",
              "marker": "7.",
              "level": "main",
              "text": "The FATF Standards on transparency and beneficial ownership of legal arrangements – R.25 – require countries to assess the ML/TF risks linked to legal arrangements and take mitigating measures.",
              "children": []
            },
            {
              "id": "clause-8-2",
              "type": "clause",
              "marker": "8.",
              "level": "main",
              "text": "This section of the Guidance aims at assisting countries and the private sector in better understanding the scope of application of transparency requirements for legal arrangements under the FATF Standards. It will discuss the distinction between legal persons and legal arrangements and then focus on the features and examples of express trusts in an effort to support countries in identifying what constitutes a legal arrangement similar to an express trust.",
              "children": []
            },
            {
              "id": "subheading-express-trusts-3",
              "type": "subheading",
              "text": "2.1 Express trusts",
              "subsectionIndex": 0
            },
            {
              "id": "clause-9-4",
              "type": "clause",
              "marker": "9.",
              "level": "main",
              "text": "The term express trusts (hereinafter, “trusts”) is defined in the Glossary to the FATF Recommendations and means a trust clearly created by the settlor, usually in the form of a document (such as the written instrument of the trust). In contrast, there are also trusts which come into being through the operation of the law and do not result from the settlor’s clear intent or decision to create a trust or similar legal arrangement.",
              "children": []
            },
            {
              "id": "clause-10-5",
              "type": "clause",
              "marker": "10.",
              "level": "main",
              "text": "Trusts are an arrangement governing the relationship between the parties (particularly the settlor, trustee and beneficiaries) and the assets and do not have their own legal personality. The trustee is the legal owner of the assets and enters into agreements on behalf of the trust.",
              "children": []
            },
            {
              "id": "clause-11-6",
              "type": "clause",
              "marker": "11.",
              "level": "main",
              "text": "This type of arrangement serves the purpose of managing and distributing assets, and/or income derived from the management of the assets in accordance with the terms of the trust instrument and the fiduciary duties of the trustee.",
              "children": []
            },
            {
              "id": "clause-12-7",
              "type": "clause",
              "marker": "12.",
              "level": "main",
              "text": "Generally, trusts are categorised as trusts for persons (beneficiaries), or purposes (charitable or non-charitable) 3 and have been used in some instances where otherwise available legal forms presented impediments or failed to accommodate specific economic endeavors. The reasons for the establishment or use of trusts may typically include:",
              "children": []
            },
            {
              "id": "clause-13-8",
              "type": "clause",
              "marker": "13.",
              "level": "main",
              "text": "Asset protection (i.e., preserving assets from perceived future external risks, such as claims by creditors or risk of bankruptcy).",
              "children": []
            },
            {
              "id": "clause-14-9",
              "type": "clause",
              "marker": "14.",
              "level": "main",
              "text": "Asset management (such as facilitating business continuity).",
              "children": []
            },
            {
              "id": "clause-15-10",
              "type": "clause",
              "marker": "15.",
              "level": "main",
              "text": "Affording privacy (i.e., providing a layer of privacy, this may be considered important for cases such as the security and safety of high-profile individuals).",
              "children": []
            },
            {
              "id": "clause-16-11",
              "type": "clause",
              "marker": "16.",
              "level": "main",
              "text": "Overcoming legal obstacles (such as requirements for residency).",
              "children": []
            },
            {
              "id": "clause-17-12",
              "type": "clause",
              "marker": "17.",
              "level": "main",
              "text": "Tax planning, and optimisation (i.e., in some countries, trusts may be taxed at a different rate compared to companies or beneficiaries).",
              "children": []
            },
            {
              "id": "clause-18-13",
              "type": "clause",
              "marker": "18.",
              "level": "main",
              "text": "Estate planning and succession (such as the death of a settlor, wasteful actions of the beneficiary and providing for a vulnerable beneficiary).",
              "children": []
            },
            {
              "id": "clause-19-14",
              "type": "clause",
              "marker": "19.",
              "level": "main",
              "text": "Holding of an investment commercial vehicle (such as pension funds).",
              "children": []
            },
            {
              "id": "clause-20-15",
              "type": "clause",
              "marker": "20.",
              "level": "main",
              "text": "Certain types of trusts, for example as described in Box 2.1, can also have different purposes than those described above, thus reinforcing the need to specifically consider and assess each arrangement’s functions and characteristics in line with applicable requirements and ML/TF risks.",
              "children": []
            },
            {
              "id": "content-box-box-2-1-charitable-trusts-16",
              "type": "contentBox",
              "title": "Box 2.1. Charitable Trusts",
              "text": "Box 2.1. Charitable Trusts Charitable trusts can be set up for an interest to be directed at a particular charitable purpose, rather than a group of people. As such, there are no identifiable beneficiaries. A charitable trust is settled for a ‘purpose’ which is usually a category of purposes falling within a special test established by the English case of Pemsel.1 It can include several different types of charitable purposes or focus on a particular one (e.g., research, education). In such instances, it can operate like a corporation created for a specified charitable purpose to hold the assets.While they are set up in ways that are comparable to express trusts, charitable trusts have a number of distinct features: Charitable purpose: all charitable trusts are created to benefit the public in some way. Indefinite beneficiaries: As no individual beneficiary can lay claims to the trust, the charitable trust is enforced by the Attorney General (or equivalent) of the state in which the trust is located or enforced by a Court or other statutory authority as appropriate, in the jurisdiction the trust is located. Duration: The Rule Against Perpetuities does not apply to charitable trusts, which may continue as long as the charitable purpose exists. While pursuing public good objectives sets charitable trusts (and similar legal arrangements such as Waqf) apart from other types of trusts, it is not possible to conclude in absolute terms that they present a lower risk. Indeed, some of their features may create an enhanced risk of misuse for ML/TF. The above shows that a priori conclusions cannot be drawn on specific (categories) of legal arrangements, and that any assessment needs to be anchored to the legal framework of a country and its risk, context and materiality. 1. The case considered an old English statute, the Statute of Elizabeth, and provides for charitable trusts – (i) for the relief of poverty; (ii) for the advancement of education; (iii) for the advancement of religion; and (iv) for other purposes beneficial to the community, not falling under any of (i)-(iii).",
              "blocks": [
                {
                  "id": "paragraph--0",
                  "type": "paragraph",
                  "text": "Charitable trusts can be set up for an interest to be directed at a particular charitable purpose, rather than a group of people. As such, there are no identifiable beneficiaries. A charitable trust is settled for a ‘purpose’ which is usually a category of purposes falling within a special test established by the English case of Pemsel.1 It can include several different types of charitable purposes or focus on a particular one (e.g., research, education). In such instances, it can operate like a corporation created for a specified charitable purpose to hold the assets.While they are set up in ways that are comparable to express trusts, charitable trusts have a number of distinct features:"
                },
                {
                  "id": "clause--1",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Charitable purpose: all charitable trusts are created to benefit the public in some way.",
                  "children": []
                },
                {
                  "id": "clause--2",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Indefinite beneficiaries: As no individual beneficiary can lay claims to the trust, the charitable trust is enforced by the Attorney General (or equivalent) of the state in which the trust is located or enforced by a Court or other statutory authority as appropriate, in the jurisdiction the trust is located.",
                  "children": []
                },
                {
                  "id": "clause--3",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Duration: The Rule Against Perpetuities does not apply to charitable trusts, which may continue as long as the charitable purpose exists.",
                  "children": []
                },
                {
                  "id": "paragraph--4",
                  "type": "paragraph",
                  "text": "While pursuing public good objectives sets charitable trusts (and similar legal arrangements such as Waqf) apart from other types of trusts, it is not possible to conclude in absolute terms that they present a lower risk. Indeed, some of their features may create an enhanced risk of misuse for ML/TF. The above shows that a priori conclusions cannot be drawn on specific (categories) of legal arrangements, and that any assessment needs to be anchored to the legal framework of a country and its risk, context and materiality. 1. The case considered an old English statute, the Statute of Elizabeth, and provides for charitable trusts – (i) for the relief of poverty; (ii) for the advancement of education; (iii) for the advancement of religion; and (iv) for other purposes beneficial to the community, not falling under any of (i)-(iii)."
                }
              ]
            },
            {
              "id": "subheading-identifying-legal-arrangements-similar-to-express-trusts-17",
              "type": "subheading",
              "text": "2.2 Identifying legal arrangements similar to express trusts",
              "subsectionIndex": 1
            },
            {
              "id": "clause-14-18",
              "type": "clause",
              "marker": "14.",
              "level": "main",
              "text": "The FATF Glossary defines legal arrangements as express trusts and other similar legal arrangements. Examples of other similar legal arrangements may include but are not limited to fiducie, certain types of Treuhand, fideicomiso, and Waqf.",
              "children": []
            },
            {
              "id": "clause-15-19",
              "type": "clause",
              "marker": "15.",
              "level": "main",
              "text": "There is no universally accepted definition of what constitutes a similar legal arrangement to a trust. Assessing whether a legal arrangement is similar to an express trust requires a comprehensive and contextual analysis of various factors. The similarity of a legal arrangement with that of an express trust may be assessed by having regard to Article 2 of the Hague Convention on the law applicable to trusts and their recognition on the basis of whether legal arrangements have a similar structure or perform a similar function to an express trust. 4 It should be considered that similar legal arrangements may exist regardless of whether a country is a party to the said Convention or whether countries have recognised or regulated express trusts.",
              "children": []
            },
            {
              "id": "clause-16-20",
              "type": "clause",
              "marker": "16.",
              "level": "main",
              "text": "Since trusts were initially developed under common law systems, similar legal arrangements developed in civil law contexts are not expected to replicate the trust concept identically. This, however, does not mean that civil law countries may be exempt from assessing their consideration under R.25 and whether trusts and/or similar legal arrangements are contemplated for in and governed under their law. Legal arrangements evolve to fit the legal context in which they operate.",
              "children": []
            },
            {
              "id": "clause-17-21",
              "type": "clause",
              "marker": "17.",
              "level": "main",
              "text": "Like express trusts, similar legal arrangements may enable a functional separation of ownership into two parts: legal control of assets, and benefit from these assets, held by different persons. Similar legal arrangements may also provide for a mechanism where a person entrusts assets to another person who holds the title to it and manages it for the benefit of one or more other persons or for a specific purpose. They may therefore create a fiduciary obligation5 that can be likened to the one imposed on the trustee of a trust.",
              "children": []
            },
            {
              "id": "clause-18-22",
              "type": "clause",
              "marker": "18.",
              "level": "main",
              "text": "Countries may follow several steps to identify similar legal arrangements within their jurisdiction:",
              "children": []
            },
            {
              "id": "clause-19-23",
              "type": "clause",
              "marker": "19.",
              "level": "main",
              "text": "Countries should assess whether their legislation explicitly provides for express trusts and/or similar legal arrangements. This determination will also require the consideration of similarity, where countries are encouraged to involve contract law experts and other trust practitioners.",
              "children": []
            },
            {
              "id": "clause-20-24",
              "type": "clause",
              "marker": "20.",
              "level": "main",
              "text": "Countries should consider the structure and purpose of all other legal arrangements in their jurisdiction. To this end, it may be useful to assess relevant case law (law established by following decisions made by judges in earlier cases – legal precedents) resulting in the recognition of certain arrangements in the country. For example, certain arrangements between individuals developing within the scope of the freedom of contracts may have been recognised without explicit regulation.",
              "children": []
            },
            {
              "id": "clause-21-25",
              "type": "clause",
              "marker": "21.",
              "level": "main",
              "text": "It may also be appropriate to assess the legislator’s intention in providing for these legal arrangements (e.g., in some cases the intention is specifically to provide, within a civil law jurisdiction, an alternative to express trusts recognised under the Hague Convention in common law countries).",
              "children": []
            },
            {
              "id": "subheading-scoping-issues-26",
              "type": "subheading",
              "text": "2.3 Scoping issues",
              "subsectionIndex": 2
            },
            {
              "id": "clause-19-27",
              "type": "clause",
              "marker": "19.",
              "level": "main",
              "text": "When assessing the similarity, it is important that both the structure and the function are assessed. In practice, countries should assess all categories of legal instruments covered under their law to determine whether they qualify as a legal arrangement because their structure or function is similar to an express trust. In addition to those covered in the FATF Glossary, instruments which countries may determine to be legal arrangements include certain types of nominee arrangements, investment vehicles, and foundations. Nominee arrangements are also covered under R.24 Guidance on Transparency of Legal Persons (Section 15: Mechanisms for preventing and mitigating risk of the misuse of nominee arrangements) and countries should take into account R.24 Guidance in relation to them in considering whether they are similar legal arrangements under R.25.",
              "children": []
            },
            {
              "id": "clause-20-28",
              "type": "clause",
              "marker": "20.",
              "level": "main",
              "text": "Further, it may be useful for countries to indicate whether the assessment concludes that some types of legal instruments are not similar to an express trust and the rationale behind this determination.",
              "children": []
            },
            {
              "id": "clause-21-29",
              "type": "clause",
              "marker": "21.",
              "level": "main",
              "text": "For example, while foundations are mentioned in the FATF Glossary as legal persons, and as having legal personality fall under the scope of R.24, they may have a structure and functions similar to a trust. 6 In this context, the FATF Standards grant sufficient flexibility to countries in setting out which rule – in line with R.24 or R.25 – can be used to determine the beneficial owner depending on the instrument’s structure and function, provided that it is included under either R.24 or R.25.",
              "children": []
            },
            {
              "id": "subheading-parties-to-a-trust-30",
              "type": "subheading",
              "text": "2.4 Parties to a trust",
              "subsectionIndex": 3
            },
            {
              "id": "clause-22-31",
              "type": "clause",
              "marker": "22.",
              "level": "main",
              "text": "Trusts may include a range of parties, including: (i) the settlor(s); (ii) the trustee(s); (iii) the protector(s) (if any); (iv) each beneficiary, or where applicable, the class(es) of beneficiaries and objects of a power; and (v) any other natural person(s) exercising ultimate effective control over the arrangement. 7",
              "children": []
            },
            {
              "id": "clause-23-32",
              "type": "clause",
              "marker": "23.",
              "level": "main",
              "text": "Countries should require trustees to obtain and hold adequate, accurate, and up-to-date beneficial ownership information of all the parties to the trust listed above subject to the condition that for beneficiaries of trusts that are designated by characteristics or by class, trustees are not expected to obtain fully adequate and accurate information until the person becomes entitled as beneficiary at the time of the payout or when the beneficiary intends to exercise vested rights, as per the risk- based approach. 8 Countries may also decide, following the risk-based approach, that it is not necessary to identify the individual beneficiaries of certain charitable or statutory permitted non-charitable trusts. It should be noted that in some cases the parties to the trusts may be legal persons or arrangements. Where the trustee or any other party to the legal arrangement is a legal person or arrangement, the trustee or equivalent should also obtain and hold adequate, accurate, and up-to-date beneficial ownership information of that legal person or arrangement. In those cases, the trustee should obtain sufficient information on who is the beneficial owner of the legal person or arrangement which is a trust party and take reasonable measures to verify its identity (see FATF Guidance on Beneficial Ownership of Legal Persons – R.24).",
              "children": []
            },
            {
              "id": "subheading-settlor-33",
              "type": "subheading",
              "text": "2.5 Settlor",
              "subsectionIndex": 4
            },
            {
              "id": "clause-24-34",
              "type": "clause",
              "marker": "24.",
              "level": "main",
              "text": "Settlors are natural or legal persons who transfer ownership of their assets to trustees by means of a trust deed or similar arrangement. A person is also a settlor if they have provided (or undertaken to provide) property or funds for the trust. This requires an element of bounty (i.e., the settlor must intend to provide some form of benefit rather than being an independent third party transferring something to the trust for full consideration). A settlor is generally understood as the person (or persons) establishing a trust. 9",
              "children": []
            },
            {
              "id": "clause-25-35",
              "type": "clause",
              "marker": "25.",
              "level": "main",
              "text": "A settlor may or may not be named in the trust instrument (deed). It is possible that the settlor named as such in a trust instrument is not the real ‘economic settlor’ i.e., the named settlor is effectively only acting as a ‘nominee’ for the real economic settlor who is the real owner of the assets contributed to the trust. In these instances, additional consideration may be needed as to how to identify the economic settlor.",
              "children": []
            },
            {
              "id": "clause-26-36",
              "type": "clause",
              "marker": "26.",
              "level": "main",
              "text": "In addition, where the settlor or any other party to the legal arrangement holding a similar role is a legal person, the beneficial owner of that legal person should be identified (see section 5).",
              "children": []
            },
            {
              "id": "subheading-trustee-37",
              "type": "subheading",
              "text": "2.6 Trustee",
              "subsectionIndex": 5
            },
            {
              "id": "clause-27-38",
              "type": "clause",
              "marker": "27.",
              "level": "main",
              "text": "Trustees are the legal, or natural, person who can act in relation to trust assets. The trustee has powers over the trust assets subject to certain obligations. The trustee’s powers and duties are generally derived from the trust instrument, as well as case law and legislation in some countries.",
              "children": []
            },
            {
              "id": "clause-28-39",
              "type": "clause",
              "marker": "28.",
              "level": "main",
              "text": "Trustees are directly involved in trust transactions, or generally are required to conduct ongoing oversight and scrutiny of others who are dealing with the trust property, and they are the central source of information on the trust and parties to the trust.",
              "children": []
            },
            {
              "id": "clause-29-40",
              "type": "clause",
              "marker": "29.",
              "level": "main",
              "text": "In line with the FATF Glossary, the term trustee should be understood as described in and consistent with Article 2(c) of the Hague Convention on the law applicable to trusts and their recognition. Trustees may be professional (e.g., depending on the jurisdiction, a lawyer or trust company) if they are paid to act as a trustee in the course of their business, or a non-professional who is not in the business of being a trustee (e.g., a person acting on behalf of the family on a non-professional basis).",
              "children": []
            },
            {
              "id": "clause-30-41",
              "type": "clause",
              "marker": "30.",
              "level": "main",
              "text": "By virtue of the role that trustees play within a legal arrangement all – professional and non-professional trustees – must comply with requirements under R.25.",
              "children": []
            },
            {
              "id": "clause-31-42",
              "type": "clause",
              "marker": "31.",
              "level": "main",
              "text": "Traditionally, trustees were under an obligation to perform their management, administration, and investment functions personally and not to delegate those functions, except as provided for by the trust instrument. More recent legislation has, in many jurisdictions, widened the scope for delegation, e.g., through provisions for trustees to appoint custodians, investment managers, investment advisors, and other service providers to assist them in properly administering the trust. However, the trustee generally remains responsible for monitoring and reviewing the arrangements under which a delegate acts.",
              "children": []
            },
            {
              "id": "clause-32-43",
              "type": "clause",
              "marker": "32.",
              "level": "main",
              "text": "Provided the deed permits it, trustees may authorise delegation of powers by:",
              "children": []
            },
            {
              "id": "clause-33-44",
              "type": "clause",
              "marker": "33.",
              "level": "main",
              "text": "power of attorney; or (ii) appointment of agent or service providers to the trust to access additional expertise, e.g., investment advisors or managers, accountants, and tax advisors. In both cases, the trustee generally remains responsible for monitoring and reviewing the arrangements under which a delegate acts. To determine whether a delegate is effectively the one administering a trust, and in line with the above, it needs to be assessed whether the delegate is: (i) proactively involved in trust transactions and able to conduct ongoing oversight and scrutiny of others who are dealing with the trust property; and (ii) acting as a central source of information on the trust and parties to the trust. In substance, an administrator’s activity span will be identical or very similar to that of a trustee, save that the power to exercise discretion concerning the disposition of the trust property rests with the latter. In modern international trust practice, it is common for the administrator to offer a comprehensive package of services, including liaising with beneficiaries, drafting minutes, instructing banks, and preparing financial statements. The firm offering the administration services may appoint professional trustees from amongst the firm’s staff to act as trustees for trusts. These may make up the whole of the trustees of a trust or may be supplemented by individuals known to the settlor (often family members or close associates).",
              "children": []
            },
            {
              "id": "paragraph--45",
              "type": "paragraph",
              "text": "The following activities carried out in isolation by expert delegates are not considered to be administering a trust:"
            },
            {
              "id": "paragraph--45-delegate-0",
              "type": "clause",
              "marker": "i.",
              "level": "nested",
              "text": "investment advice or management;",
              "children": []
            },
            {
              "id": "paragraph--45-delegate-1",
              "type": "clause",
              "marker": "ii.",
              "level": "nested",
              "text": "custodian services;",
              "children": []
            },
            {
              "id": "paragraph--45-delegate-2",
              "type": "clause",
              "marker": "iii.",
              "level": "nested",
              "text": "legal advice;",
              "children": []
            },
            {
              "id": "paragraph--45-delegate-3",
              "type": "clause",
              "marker": "iv.",
              "level": "nested",
              "text": "tax advice;",
              "children": []
            },
            {
              "id": "paragraph--45-delegate-4",
              "type": "clause",
              "marker": "v.",
              "level": "nested",
              "text": "management of real estate;",
              "children": []
            },
            {
              "id": "paragraph--45-delegate-5",
              "type": "clause",
              "marker": "vi.",
              "level": "nested",
              "text": "accounting services; and",
              "children": []
            },
            {
              "id": "paragraph--45-delegate-6",
              "type": "clause",
              "marker": "vii.",
              "level": "nested",
              "text": "book-keeping services.",
              "children": []
            },
            {
              "id": "clause-vi-46-continuation",
              "type": "paragraph",
              "text": "In this context, an administrator is normally, but not exclusively, a person other than a trustee (e.g., TCSPs, accountants) who is (i) proactively involved in trust transactions and able to conduct ongoing due diligence and scrutiny of transactions of others who are dealing with the trust property; and (ii) acting as a central source of information on the trust and parties to the trust."
            },
            {
              "id": "paragraph--47",
              "type": "paragraph",
              "text": "Those experts who provide services to underlying investments of trusts, e.g., acting as a director to a trading company held in a trust, are not to be considered as administering the trust."
            },
            {
              "id": "paragraph--48",
              "type": "paragraph",
              "text": "The appointment of an administrator (a central co-ordinator) may be more common for trusts with several trustees and where activities are complex or numerous, where professional administration support is needed."
            },
            {
              "id": "subheading-protector-49",
              "type": "subheading",
              "text": "2.7 Protector",
              "subsectionIndex": 6
            },
            {
              "id": "clause-36-50",
              "type": "clause",
              "marker": "36.",
              "level": "main",
              "text": "There is no universal definition of the term protector, and a protector’s duties and powers may vary widely between jurisdictions and trusts. A protector, appointor, or guardian is generally appointed to oversee trustees’ actions and to consider whether such actions are in the interest of the beneficiaries. These legal or natural persons may protect and ultimately control a trust because:",
              "children": []
            },
            {
              "id": "clause-37-51",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "they may approve the trustee’s decisions.",
              "children": []
            },
            {
              "id": "clause-38-52",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "they may revoke a trustee’s decisions.",
              "children": []
            },
            {
              "id": "clause-39-53",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "they may remove a trustee.",
              "children": []
            },
            {
              "id": "clause-40-54",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "they may appoint a new trustee.",
              "children": []
            },
            {
              "id": "clause-41-55",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "they may change the jurisdiction of the trust.",
              "children": []
            },
            {
              "id": "clause-42-56",
              "type": "clause",
              "marker": "37.",
              "level": "main",
              "text": "A trustee is expected to obtain information to enable it to identify and verify the identity of the protector. In some cases, a protector may be a legal person.",
              "children": []
            },
            {
              "id": "subheading-natural-person-exercising-effective-control-57",
              "type": "subheading",
              "text": "2.8 Natural person exercising effective control",
              "subsectionIndex": 7
            },
            {
              "id": "clause-38-58",
              "type": "clause",
              "marker": "38.",
              "level": "main",
              "text": "In addition to the parties to the trust mentioned above, other natural persons may exercise effective control over the legal arrangement. Ultimate effective control over trusts or similar legal arrangements includes:",
              "children": []
            },
            {
              "id": "clause-39-59",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "situations in which ownership/control is exercised through a chain of ownership/control; and/or",
              "children": []
            },
            {
              "id": "clause-40-60",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "any other individual with the power to decide who can exert control over the trust.",
              "children": []
            },
            {
              "id": "content-box-box-2-2-natural-person-exercising-effective-control-61",
              "type": "contentBox",
              "title": "Box 2.2. Natural person exercising effective control",
              "text": "Box 2.2. Natural person exercising effective control “Control” means a power (whether exercisable alone or jointly with another person or with the consent of another person) under the trust instrument or by law to: dispose of or invest (other than as an investment manager) trust property; direct, make or approve trust distributions; vary or terminate the trust; add or remove a person as a beneficiary or to or from a class of beneficiaries; and/or appoint or remove trustees. Source: FATF, Risk-Based Approach Guidance for Legal Professionals, pp 71, 2019",
              "blocks": [
                {
                  "id": "paragraph--0",
                  "type": "paragraph",
                  "text": "“Control” means a power (whether exercisable alone or jointly with another person or with the consent of another person) under the trust instrument or by law to:"
                },
                {
                  "id": "clause-i-1",
                  "type": "clause",
                  "marker": "i.",
                  "level": "main",
                  "text": "dispose of or invest (other than as an investment manager) trust property;",
                  "children": []
                },
                {
                  "id": "clause-ii-2",
                  "type": "clause",
                  "marker": "ii.",
                  "level": "main",
                  "text": "direct, make or approve trust distributions;",
                  "children": []
                },
                {
                  "id": "clause-iii-3",
                  "type": "clause",
                  "marker": "iii.",
                  "level": "main",
                  "text": "vary or terminate the trust;",
                  "children": []
                },
                {
                  "id": "clause-iv-4",
                  "type": "clause",
                  "marker": "iv.",
                  "level": "main",
                  "text": "add or remove a person as a beneficiary or to or from a class of beneficiaries; and/or",
                  "children": []
                },
                {
                  "id": "clause-v-5",
                  "type": "clause",
                  "marker": "v.",
                  "level": "main",
                  "text": "appoint or remove trustees. Source: FATF, Risk-Based Approach Guidance for Legal Professionals, pp 71, 2019",
                  "children": []
                }
              ]
            },
            {
              "id": "subheading-beneficiaries-62",
              "type": "subheading",
              "text": "2.9 Beneficiaries",
              "subsectionIndex": 8
            },
            {
              "id": "clause-39-63",
              "type": "clause",
              "marker": "39.",
              "level": "main",
              "text": "A beneficiary of a trust is the person(s) who is(are) or may become entitled to the benefit, directly or indirectly, of any trust arrangement. A beneficiary can be a natural person, or a legal person or arrangement. All trusts (other than charitable or statutory permitted non-charitable trusts) are required to have ascertainable beneficiaries. While trusts must always have some ultimately ascertainable beneficiary, trusts may have no defined existing beneficiaries when they are set up but only a class of beneficiaries with persons who are objects of a power (see Section on Object of a power) until, for example, some person becomes entitled as a beneficiary to income or capital on the expiry of a defined period, known as the accumulation period, or following the exercise of trustee discretion in the case of a discretionary trust. 10",
              "children": []
            },
            {
              "id": "clause-40-64",
              "type": "clause",
              "marker": "40.",
              "level": "main",
              "text": "In regard to those persons who may become entitled to the benefit of a legal arrangement, trustees may be given varying levels of discretionary power through provisions in the trust instrument, to select which of a group of persons shall receive any benefit at all from the trust (e.g., no discretion at all on the beneficiaries or some given discretion). Alternatively, while the trust instrument may provide that each member of a class of beneficiaries is to receive some benefit, the trustee may be given the power to determine how much each beneficiary will receive at the trustee’s discretion. Similarly, the trustee may also be given the power to decide, at their discretion, whether to distribute income, or to accumulate it.",
              "children": []
            },
            {
              "id": "clause-41-65",
              "type": "clause",
              "marker": "41.",
              "level": "main",
              "text": "Accordingly, a beneficiary may include:",
              "children": []
            },
            {
              "id": "clause-42-66",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "those explicitly named in the trust instrument (trust deed) as a beneficiary or beneficiaries.",
              "children": []
            },
            {
              "id": "clause-43-67",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "those who may not be explicitly named but who can be clearly identified as being entitled to the benefit of a particular legal arrangement (e.g., a child of the settlor if the trust instrument names the beneficiaries as being the settlor’s children).",
              "children": []
            },
            {
              "id": "clause-44-68",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "those who become beneficiaries at the occurrence of a specific event, such as the exercise of trustee discretion (objects of a power) or the realisation of an accumulation period.",
              "children": []
            },
            {
              "id": "clause-45-69",
              "type": "clause",
              "marker": "45.",
              "level": "main",
              "text": "The requirement to obtain and hold adequate, accurate, and up-to-date beneficial ownership information regarding the trust under R.25 applies to all current beneficiaries, with certain exceptions in the case of those identified by class as per INR.25.1. Separate provisions apply for beneficiaries who are objects of a power that will be exercised under a discretionary trust.",
              "children": []
            },
            {
              "id": "clause-46-70",
              "type": "clause",
              "marker": "46.",
              "level": "main",
              "text": "Where there are no ascertainable beneficiaries at the time of setting up the trust, then as per INR.25.1, the trustee should obtain and hold some information on the class of beneficiaries and its characteristics, and objects of a power (see section below). 11 Following a risk-based approach, countries may decide that it is not necessary to identify the individual beneficiaries of certain charitable or statutory permitted non-charitable trusts. This decision should be based on a risk assessment of this type of trusts and should clearly align with the findings of that risk assessment.",
              "children": []
            },
            {
              "id": "clause-47-71",
              "type": "clause",
              "marker": "47.",
              "level": "main",
              "text": "It is essential for the trustees to know who the beneficiaries are, so that they can ensure that the beneficiaries’ interests are properly considered. Not only must there be beneficiaries, but trustees must be conscious about their identity, or else they are, in practice, unable to perform the trust.",
              "children": []
            },
            {
              "id": "clause-48-72",
              "type": "clause",
              "marker": "48.",
              "level": "main",
              "text": "Where trustees are given broad discretionary powers, it is not necessary for them to identify all possible beneficiaries because the trust may be drafted widely enough to include beneficiaries unborn or otherwise unidentified at the time of creation (e.g., family inheritance). Similarly, it may not be practicable to identify everybody who could be entitled at any one time; and the inability to classify the whole class would not cause the trust to fail due to lack of certainty of objects. The trustee has a duty to survey the range of beneficiaries before considering the appropriateness of distribution(s) and to determine with certainty whether an individual is or is not a member of a class and whether that person is or is not a person who is able to receive a benefit from the trust (i.e., a beneficiary or object of a power).",
              "children": []
            },
            {
              "id": "subheading-object-of-a-power-73",
              "type": "subheading",
              "text": "2.10 Object of a power",
              "subsectionIndex": 9
            },
            {
              "id": "clause-46-74",
              "type": "clause",
              "marker": "46.",
              "level": "main",
              "text": "Not all trusts will have an ‘object of a power’. However, where they exist, there are two (cumulative) elements to the definition of “object of a power”:",
              "children": []
            },
            {
              "id": "clause-46-74-object-of-power-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "First, the person must have been identified by the trustee as a member of a class of possible beneficiaries, for whom there is yet no identifiable trust property/fixed interest. Until the trustee exercises their discretionary powers, the objects of power are not more than likely to benefit.",
              "children": []
            },
            {
              "id": "clause-46-74-object-of-power-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "Second, the trustee must have a clear and realistic belief that, under the terms of the trust, the possible beneficiary may, in fact, benefit from trust property in the future. This may be because the person is referred to in a letter of wishes (or similar) provided by the settlor. It may also be because the class has narrowed for a variety of reasons to a very small number of likely beneficiaries.",
              "children": []
            },
            {
              "id": "clause-47-75",
              "type": "clause",
              "marker": "47.",
              "level": "main",
              "text": "A particular possible beneficiary may not be aware that they are an “object of a power” as there may be instances where the trust instrument provides that a possible beneficiary is not to be informed of their likely entitlement until a discretion is exercised in their favour, until they attain a specific age, or some other occurrence. There may be situations where it may be deemed that no beneficiaries are ascertainable at a certain point in time if no discretions have been exercised by the trustee.",
              "children": []
            },
            {
              "id": "clause-48-76",
              "type": "clause",
              "marker": "48.",
              "level": "main",
              "text": "Other documents such as a letter of wishes, may clearly indicate a person as being a beneficiary or ‘an object of a power’. Although letters of wishes are not binding on trustees, in practice some trust instruments may set out very generic classes of beneficiaries and then spell out in significant detail how the settlor ‘wishes’ for the trustee to administer and eventually distribute the trust fund to specific individuals. Although the trustee is legally entitled to refuse the settlor’s wishes set out in the letter of wishes, in practice, this is generally given significant weight. Therefore, any persons specifically named therein should, in principle, be deemed “objects of a power”.",
              "children": []
            }
          ]
        },
        {
          "number": "3",
          "label": "Section 3",
          "title": "Understanding and assessing the risks associated with trusts and similar legal arrangements",
          "hideLabel": false,
          "body": "",
          "blocks": [
            {
              "id": "clause-49-0",
              "type": "clause",
              "marker": "49.",
              "level": "main",
              "text": "Understanding the ML/TF risks associated with trusts and similar legal arrangements requires the assessment of their nature and context. In most instances the ML/TF risks are commonly associated with the ways in which these instruments can represent obstacles to transparency including, but not limited to:",
              "children": []
            },
            {
              "id": "clause-50-1",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "The private nature of the arrangements.",
              "children": []
            },
            {
              "id": "clause-51-2",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Choice of law.",
              "children": []
            },
            {
              "id": "clause-52-3",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Ease of formation.",
              "children": []
            },
            {
              "id": "clause-53-4",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Flexibility.",
              "children": []
            },
            {
              "id": "clause-54-5",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Potential overlap of several parties to the trust.",
              "children": []
            },
            {
              "id": "clause-55-6",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Flee clause.",
              "children": []
            },
            {
              "id": "clause-56-7",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Protection of assets.",
              "children": []
            },
            {
              "id": "clause-57-8",
              "type": "clause",
              "marker": "57.",
              "level": "main",
              "text": "Moreover, ML/TF risks associated with trusts sometimes derive from the multiple layers and distance that can be created between the beneficiary and the other parties to the legal arrangements, as well as the multi-jurisdictional elements that increase challenges for identification, overall collection and verification of information, and international co-operation (e.g., when the place of administration, location of the trust asset, and residences 12 of the trustee, settlor and/or beneficiary are in separate jurisdictions).",
              "children": []
            },
            {
              "id": "subheading-private-nature-of-the-arrangement-9",
              "type": "inlineHeading",
              "text": "Private nature of the arrangement",
              "subsectionIndex": 0
            },
            {
              "id": "clause-51-10",
              "type": "clause",
              "marker": "51.",
              "level": "main",
              "text": "One of the key features of trusts and other similar legal arrangements that makes them vulnerable to misuse lies in their greater degree of privacy than alternative instruments. Trusts are essentially relationships among persons – specifically, an agreement between the settlor and the trustee to administer the trust property for the benefit of trust beneficiaries. The same applies to similar arrangements, many of which have developed without a specific legal framework. The terms of a contract are generally private between the parties, and in some trusts and legal arrangements the terms or even the existence of the trust may be private from some of the parties. For example, a trust established for a child when he/she becomes an adult.",
              "children": []
            },
            {
              "id": "clause-52-11",
              "type": "clause",
              "marker": "52.",
              "level": "main",
              "text": "Given the private nature of such arrangements, regulatory requirements applicable to trusts or similar legal arrangements, where they exist, are generally not comparable to those in place for legal persons (in some countries, exceptions exist concerning similar legal arrangements such as the fiducie). Registration of trusts and other legal arrangements is also not always required, with some exceptions (e.g., tax purposes, specific trusts set up in financial centres, or other specific registration requirements such as in the context of Waqf).",
              "children": []
            },
            {
              "id": "clause-53-12",
              "type": "clause",
              "marker": "53.",
              "level": "main",
              "text": "Given the private nature of trusts, the identity of the parties is usually only disclosed by the trustee to FIs, DNFBPs, and to competent authorities in exercise of their powers. In some countries, particularly restrictive conditions might render the identification of the parties to the trusts extremely difficult, hampering international co-operation when it comes to exchanging information on the identity of those parties.",
              "children": []
            },
            {
              "id": "clause-53-12-choice-of-law",
              "type": "inlineHeading",
              "text": "Choice of law"
            },
            {
              "id": "clause-54-13",
              "type": "clause",
              "marker": "54.",
              "level": "main",
              "text": "Article 6 of the Hague Convention notes that a trust is governed by the law chosen by the settlor, whether implicitly or explicitly. This means that settlors remain free to choose under which legal framework to create a trust and, therefore, the associated safeguards. The choice of law could pose ML/TF risks because, for instance, it could lead to regulatory arbitrage or to complications adjudicating issues to the trust if it is formed under the laws of one jurisdiction and administrated in another.",
              "children": []
            },
            {
              "id": "clause-54-13-ease-of-formation",
              "type": "inlineHeading",
              "text": "Ease of formation"
            },
            {
              "id": "clause-55-14",
              "type": "clause",
              "marker": "55.",
              "level": "main",
              "text": "The formation of the legal arrangement may be relatively simple, as it may involve the simple drawing up of a trust instrument, usually by a notary or lawyer. Combined with greater degree of privacy of the trusts to the extent that they are not always subject to registration, the simplicity of creating a trust makes it possible to transfer the legal and equitable ownership of assets without making that transfer open to public knowledge. Beneficiaries of the trust may not be aware of their status in some cases.",
              "children": []
            },
            {
              "id": "subheading-flexibility-15",
              "type": "inlineHeading",
              "text": "Flexibility",
              "subsectionIndex": 1
            },
            {
              "id": "clause-56-16",
              "type": "clause",
              "marker": "56.",
              "level": "main",
              "text": "The fact that trusts and other legal arrangements can generally be created by a simple instrument (usually in the form of a document) subject to freedom to contract makes the trust a flexible vehicle for the management of assets. In many instances, this flexibility is provided as trustees administer the trust assets for the benefit of the trust beneficiaries who might change over time, as might their interests and needs. Among the main flexibility elements that are of relevance for AML/CFT purposes are:",
              "children": []
            },
            {
              "id": "clause-57-17",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "The possibility for trust instruments not to include the names of all parties of the trust means that they can be easily changed without any disclosure or notification (this is irrespective of the duty of the trustee to retain a minimum set of information on all parties to the trust).",
              "children": []
            },
            {
              "id": "clause-58-18",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "The possibility for the settlor to retain control over the trust (without expressly retaining rights in the trust instrument), for example by revoking the trust or appointing a protector who is given certain powers over the trust, ostensibly in accordance with the wishes of the settlor who no longer has such authority over the trustee.",
              "children": []
            },
            {
              "id": "clause-59-19",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "The ability to shield trust assets from the beneficiaries’ creditors (other than the settlor).",
              "children": []
            },
            {
              "id": "clause-60-20",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "The power given to a trustee or settlors to name future beneficiaries of the trust, whether limited to members of a described class or otherwise.",
              "children": []
            },
            {
              "id": "clause-61-21",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "The possibility for purpose trusts (i.e., without beneficiaries/class of beneficiaries) to be set up also in the case of statutory permitted non- charitable trusts.",
              "children": []
            },
            {
              "id": "clause-62-22",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "The possibility for the settlor to retain a right to revoke the trust and reacquire the trust assets.",
              "children": []
            },
            {
              "id": "clause-63-23",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "The ease with which the legal owner of the assets can be changed (either through appointing a new trustee or distributing to a beneficiary).",
              "children": []
            },
            {
              "id": "clause-64-24",
              "type": "clause",
              "marker": "57.",
              "level": "main",
              "text": "Many of the above elements are found in ML/TF cases involving trusts, although not all are available in the law or case law surrounding trusts in all cases. The vulnerabilities could also increase with the higher number of flexibility elements allowed by national law (or case law) to be included in the actual trust.",
              "children": []
            },
            {
              "id": "clause-64-24-potential-overlap",
              "type": "inlineHeading",
              "text": "Potential overlap of several parties to the trust"
            },
            {
              "id": "clause-65-25",
              "type": "clause",
              "marker": "58.",
              "level": "main",
              "text": "Rules on how many roles in a trust the same person can have (settlor, trustee, and beneficiary) vary according to the different legal frameworks. A certain level of flexibility is allowed for trusts, particularly inter vivos, where the settlor also acts as the trustee or one of the trustees, or as protector or one of the protectors. However, a situation where the settlor coincides with the beneficiary (particularly if it is the only beneficiary) may trigger the need for additional focus on the trust’s purpose.",
              "children": []
            },
            {
              "id": "clause-65-25-flee-clause",
              "type": "inlineHeading",
              "text": "Flee clause"
            },
            {
              "id": "clause-66-26",
              "type": "clause",
              "marker": "59.",
              "level": "main",
              "text": "A flee clause is a clause in a trust instrument that, once a specific event occurs, triggers the removal of the trustee and the transfer of the trust to another trustee in a different jurisdiction. The clause, less common in modern trusts, was used to protect the assets against insecurity generated by either the trustee or the jurisdiction under whose law the trust was created. Examples of trigger events include a change of regime, breakdown of law and order, natural disaster, or a declaration of a state of emergency in the jurisdiction where the trustee is resident and/or the trust is administered. The interconnectedness and transparency requirements of the global financial system make the resort to flee clauses outdated and, to a large extent, unjustified. From an ML/TF perspective, the main concern is that the clause can be triggered upon a service of process or information request by an authority, thus in effect insulating the trust from the claims or the action of law enforcement authorities or slowing down such action.",
              "children": []
            },
            {
              "id": "clause-66-26-protection-of-assets",
              "type": "inlineHeading",
              "text": "Protection of assets"
            },
            {
              "id": "clause-67-27",
              "type": "clause",
              "marker": "60.",
              "level": "main",
              "text": "The separation of legal and beneficial ownership in trusts makes it possible for assets to be shielded from third parties through trusts. By relinquishing their property ownership to a trust, settlors also protect the assets in the trust from any third parties’ claims. This is seen in a number of cases, whereby the unequivocal position by the courts has been that once there was an effective alienation of the trust property, they are no longer part of the settlor’s assets and therefore can be secured from creditors. The assets of a trust are also generally not treated as an asset of a beneficiary (depending on the terms of the trust). To avoid abuses, some jurisdictions have implemented measures to mitigate the abuse of trust law for fraudulent objectives, such as preventing claims from debtors in the case of bankruptcy. 13 This principle is also applied in civil law courts when the fraudulent purpose of transferring assets in a trust can be demonstrated or derived from the facts surrounding the transfer. 14",
              "children": []
            },
            {
              "id": "clause-68-28",
              "type": "clause",
              "marker": "68.",
              "level": "main",
              "text": "Some jurisdictions bring additional features that result in a high level of protection of the assets from third parties or other countries. Asset protection trusts may include the following features:",
              "children": []
            },
            {
              "id": "clause-68-28-asset-protection-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "A 1-2-year statute of limitation within which a creditor must bring an action of fraudulent transfer or conveyance against a trust.",
              "children": []
            },
            {
              "id": "clause-68-28-asset-protection-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "No recognition or enforcement of foreign judgments, including foreign bankruptcy.",
              "children": []
            },
            {
              "id": "clause-68-28-asset-protection-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "There is a higher “beyond a reasonable doubt” burden of proof that the assets were placed into the trust for fraudulent purposes.",
              "children": []
            },
            {
              "id": "clause-68-28-asset-protection-3",
              "type": "clause",
              "marker": "d.",
              "level": "nested",
              "text": "Cases have to be brought to a domestic court and/or deposit paid before the country’s court system may be used.",
              "children": []
            },
            {
              "id": "subheading-risk-assessment-of-legal-arrangements-governed-under-the-law-of-a-country-29",
              "type": "subheading",
              "text": "3.3 Risk assessment of legal arrangements governed under the law of a country",
              "subsectionIndex": 2
            },
            {
              "id": "clause-62-30",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "To ensure that risks are adequately understood and mitigated, the INR.25 requires that countries should assess the ML and TF risks associated with different types of trusts and other similar legal arrangements governed under their law and take appropriate steps to manage and mitigate the risks they identify. Such a risk assessment should consider: (i) the particular vulnerabilities the country faces in relation to trusts and other similar legal arrangements, and (ii) the extent to which the country’s governing law presents opportunities for ML/TF. 15",
              "children": []
            },
            {
              "id": "clause-63-31",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "In some instances, the only connection that a trust may have with a country is the use of its trust law and use of its judicial system if there is a dispute. Assets of a trust do not need to be held in the country whose legal framework regulates the trust. Nor in many cases is it necessary for a trustee to be resident in that country, or for the trust to be administered therefrom.",
              "children": []
            },
            {
              "id": "clause-64-32",
              "type": "clause",
              "marker": "64.",
              "level": "main",
              "text": "The FATF Recommendations recognise that many countries do not have trust law and may not give legal recognition to trusts and there is no requirement for countries to do so. However, people in those countries may create trusts governed by the law of a different country to manage their assets. This means that the countries that provide the source of law for a trust may not have the necessary connection to either fully understand or mitigate risks associated with legal arrangements established under their law. In fact, since the choice of the law governing the trust is a right of the settlor, the country providing the source of law might have no means at all to know of the existence of a particular legal arrangement unless there is a connection to its territory. Conversely, this connection and the ability to assess and mitigate risks associated with these arrangements can be found in the jurisdiction where the trust is administered or where the trustee resides. Those jurisdictions are also required to assess the risks associated with those arrangements.",
              "children": []
            },
            {
              "id": "clause-65-33",
              "type": "clause",
              "marker": "65.",
              "level": "main",
              "text": "Countries providing the source of law should carry out an assessment of the vulnerabilities of their legal framework in this regard to mitigate potential ML/TF abuse.",
              "children": []
            },
            {
              "id": "clause-66-34",
              "type": "clause",
              "marker": "66.",
              "level": "main",
              "text": "For the purpose of this risk assessment, countries providing the source of law may consider also assessing specific concentrated areas of use of the country’s governing law and the reasons for that concentrated activity to the extent that such information is available. To this end, countries may also consider information about the number of trusts registered or documented (if any), data collected by law enforcement or through results from supervision of FIs/DNFBPs providing trust services, or other sources.",
              "children": []
            },
            {
              "id": "subheading-risk-assessment-of-legal-arrangements-administered-in-the-country-or-for-which-the-trustee-or-equivalent-resides-in-the-country-35",
              "type": "subheading",
              "text": "3.4 Risk assessment of legal arrangements administered in the country or for which the trustee or equivalent resides in the country",
              "subsectionIndex": 3
            },
            {
              "id": "clause-67-36",
              "type": "clause",
              "marker": "67.",
              "level": "main",
              "text": "Countries should not only assess the ML/TF risks of legal arrangements governed under their law, but also of legal arrangements governed under the law of another country which are administered in their territory, for example through trust administration services provided by a TCSP in the country, or if the trustee or equivalent resides in the country. Countries should take appropriate steps to manage and mitigate the risks they identify.",
              "children": []
            },
            {
              "id": "clause-68-37",
              "type": "clause",
              "marker": "68.",
              "level": "main",
              "text": "To assess the risks associated with legal arrangements administered in the country, countries may develop an understanding of what type of trust-related services are provided in their jurisdiction, who provides those services and the nature of these services, and the trust parties. In addition, countries should have processes in place to determine if persons residing in their jurisdiction act as a trustee for foreign legal arrangements or equivalent (including on a professional and non- professional basis). To identify whether trustees of foreign legal arrangements, or equivalent, are resident in the jurisdiction, countries could assess the information available to domestic tax authorities (e.g., tax declarations, provided that this information is accessible according to internationally agreed standards) and supervisors. 16 In this context, it is worth mentioning the importance of inter-agency co-operation and information sharing frameworks.",
              "children": []
            },
            {
              "id": "clause-69-38",
              "type": "clause",
              "marker": "69.",
              "level": "main",
              "text": "When assessing the risks associated with foreign legal arrangements administered in the country or for which the trustee or equivalent resides in the country, countries could also consider using the publicly available information about the different types, forms, and basic features of the relevant express trusts and/or other similar legal arrangements governed under the law of another country, how they are set up and how their basic and beneficial ownership information can be obtained.",
              "children": []
            },
            {
              "id": "subheading-risk-assessment-of-foreign-legal-arrangements-having-sufficient-links-with-the-country-39",
              "type": "subheading",
              "text": "3.5 Risk assessment of foreign legal arrangements having sufficient links with the country",
              "subsectionIndex": 4
            },
            {
              "id": "clause-70-40",
              "type": "clause",
              "marker": "70.",
              "level": "main",
              "text": "To ensure that risks are adequately understood and mitigated, countries should identify and assess the ML/TF risks to which they are exposed in relation to foreign legal arrangements, which have sufficient links to the country, and take appropriate steps to manage and mitigate the risks they identify. What constitutes a sufficient link may be determined on the basis of risk. 17 The jurisdiction’s context and the circumstances of a trust may be important when determining a sufficient link.",
              "children": []
            },
            {
              "id": "clause-71-41",
              "type": "clause",
              "marker": "71.",
              "level": "main",
              "text": "The examples for sufficient links with a country provided in INR.25 include but are not limited to:",
              "children": []
            },
            {
              "id": "clause-71-41-sufficient-link-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "The trust or similar legal arrangement or a trustee or a person holding an equivalent position in a similar legal arrangement has significant and ongoing business relations with FIs or DNFBPs in the country. Significant business could be in relation to the size of the relevant market and/or the impact of the business activity in the relevant market or the areas/sectors in which the trust or arrangement or a trustee or equivalent operate.",
              "children": []
            },
            {
              "id": "clause-71-41-sufficient-link-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "The trust or similar legal arrangement or a trustee or a person holding an equivalent position in a similar legal arrangement has significant real estate or other local investment in the country. Examples for such other local investment may include (but are not limited to) securities market investment. Significant real estate or other local investment could be determined with reference to the average price of the real estate and the corresponding asset market in the country, or the quantity of real estate held.",
              "children": []
            },
            {
              "id": "clause-71-41-sufficient-link-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "The trust or similar legal arrangement or a trustee or a person holding an equivalent position in a similar legal arrangement is subject to taxation in the country (e.g., value added tax, income tax, property tax, wealth tax).",
              "children": []
            },
            {
              "id": "clause-72-42",
              "type": "clause",
              "marker": "72.",
              "level": "main",
              "text": "In addition to the examples provided in INR.25, sufficient links may include cases where foreign trusts or similar legal arrangements own, or control legal persons or arrangements established within the country.",
              "children": []
            },
            {
              "id": "clause-73-43",
              "type": "clause",
              "marker": "73.",
              "level": "main",
              "text": "Countries may consider the factors set out in relation to trusts governed in their country, administered in their country or where the trustee is resident in their country, in establishing a risk assessment framework for trusts and legal arrangements with sufficient links with their country. They should also consider factors relevant to the trusts’ links with their jurisdiction.",
              "children": []
            },
            {
              "id": "subheading-mechanisms-for-preventing-and-mitigating-risk-44",
              "type": "subheading",
              "text": "3.6 Mechanisms for preventing and mitigating risk",
              "subsectionIndex": 5
            },
            {
              "id": "clause-74-45",
              "type": "clause",
              "marker": "74.",
              "level": "main",
              "text": "Countries should take appropriate steps to manage and mitigate the risks identified in the risk assessment based on the requirements set out in R.25, and other relevant Recommendations (i.e., R.10, R.24, and R.22). To enable this, the risk assessment should be comprehensive and involve sufficient analysis of the sources, nature, and the extent of risk involved.",
              "children": []
            },
            {
              "id": "clause-75-46",
              "type": "clause",
              "marker": "75.",
              "level": "main",
              "text": "To mitigate the above-mentioned risks, it is necessary to clearly establish the specific features that characterise each type of trust or similar legal arrangement, particularly the purposes of the arrangement.",
              "children": []
            },
            {
              "id": "clause-76-47",
              "type": "clause",
              "marker": "76.",
              "level": "main",
              "text": "The following illustrates risk mitigating preventive measures. Some of these measures are mandatory under R.25 (or R.22/R.23), while some go beyond existing standards, but could help mitigate risks:",
              "children": []
            },
            {
              "id": "clause-76-47-mandatory-elements",
              "type": "inlineHeading",
              "text": "Mandatory elements"
            },
            {
              "id": "clause-77-48",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "A strong understanding of relevant ML/TF risks.",
              "children": []
            },
            {
              "id": "clause-78-49",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Sanctions for trusts that operate in their country but bypass registration requirements by registering in another country.",
              "children": []
            },
            {
              "id": "clause-79-50",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Mechanisms to supervise or monitor persons administering trusts that are not TCSPs (e.g., lawyers and accountants).",
              "children": []
            },
            {
              "id": "clause-80-51",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Mechanisms for enhanced due diligence by FIs/DNFBPs that have business relationships with trusts or similar legal arrangements, where relevant and in line with a risk-based approach.",
              "children": []
            },
            {
              "id": "clause-81-52",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Mechanisms to investigate (and investigating) violations of registration requirements and/or beneficial ownership reporting rules, where in place, with special consideration to the threat posed by relevant higher risk arrangements.",
              "children": []
            },
            {
              "id": "clause-82-53",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Providing sufficient enforcement capacities and powers to the competent authorities.",
              "children": []
            },
            {
              "id": "clause-83-54",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Providing sufficient verification and enforcement capacities and powers to the trust registry (if it exists), beneficial ownership registry (if it exists), TCSP supervisor(s) or other relevant public body.",
              "children": []
            },
            {
              "id": "clause-84-55",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Introducing an international co-operation regime to provide rapid, constructive and effective international co-operation in relation to information, including beneficial ownership information on trusts and similar legal arrangements.",
              "children": []
            },
            {
              "id": "clause-84-55-additional-mitigating-measures",
              "type": "inlineHeading",
              "text": "Additional mitigating measures"
            },
            {
              "id": "clause-85-56",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "A register of trusts administered in the country or for which the trustee or equivalent resides in the country.",
              "children": []
            },
            {
              "id": "clause-86-57",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "A register of trusts governed under the law of a country (where the law is such that the trust has no legal capacity without such a registration).",
              "children": []
            },
            {
              "id": "clause-87-58",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Establishing licensing or registration requirements for professional trustees.",
              "children": []
            },
            {
              "id": "clause-88-59",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Applying R.10 to R.12 to: (i) non-professional trustees; and (ii) professional administrators of trusts that are not TCSPs.",
              "children": []
            },
            {
              "id": "clause-89-60",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Mechanisms applying disclosure requirements to legal arrangements that wish to operate in, own significant assets in, or apply for registration in a country; in addition, applying disclosure requirements to legal arrangements which receive funding from foreign sources or from sources deemed to be high risk.",
              "children": []
            },
            {
              "id": "clause-90-61",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Introducing arrangements where actors in specific sectors, particularly those deemed to be at higher risk, can detect and report activity of concern.",
              "children": []
            },
            {
              "id": "clause-91-62",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "Introducing legislative measures, such as anti-abusive provisions, limits to measures particularly vulnerable to abuse, disclosure requirements of the other parties to the trust, etc.",
              "children": []
            },
            {
              "id": "clause-92-63",
              "type": "clause",
              "marker": "92.",
              "level": "main",
              "text": "Under the FATF standards, there is no mandatory requirement for registration for express trusts and similar legal arrangements governed under a country’s law. In such context, it is acknowledged that a country may find it difficult to establish the extent to which there is foreign use of trusts governed under its law.",
              "children": []
            },
            {
              "id": "clause-93-64",
              "type": "clause",
              "marker": "93.",
              "level": "main",
              "text": "Countries should carry out an assessment of the vulnerabilities of their legal framework in this regard to mitigate potential ML/TF abuse.",
              "children": []
            }
          ]
        },
        {
          "number": "4",
          "label": "Section 4",
          "title": "Adequate, accurate and up-to-date information",
          "hideLabel": false,
          "body": "",
          "blocks": [
            {
              "id": "subheading-basic-information-0",
              "type": "subheading",
              "text": "4.1 Basic information",
              "subsectionIndex": 0
            },
            {
              "id": "clause-79-1",
              "type": "clause",
              "marker": "79.",
              "level": "main",
              "text": "Countries should ensure that there is adequate, accurate, and up-to-date information on trusts or other similar legal arrangements including information on the settlor, trustee, and beneficiarythat can be obtained or accessed efficiently and in a timely manner by competent authorities. The INR.25 describes this information as including basic information and beneficial ownership information and provides that the obligation to obtain and hold the information be imposed on the trustee or person holding an equivalent position.",
              "children": []
            },
            {
              "id": "clause-80-2",
              "type": "clause",
              "marker": "80.",
              "level": "main",
              "text": "Basic information about a trust or similar legal arrangement means:",
              "children": []
            },
            {
              "id": "clause-81-3",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the identifier of the legal arrangement (e.g., the name, the unique identifier such as a tax identification number or equivalent, where this exists),",
              "children": []
            },
            {
              "id": "clause-82-4",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the trust deed (or equivalent) 18 and purposes, if any 19, and",
              "children": []
            },
            {
              "id": "clause-83-5",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the residence of the trustee/equivalent or of the place from where the legal arrangement is administered.",
              "children": []
            },
            {
              "id": "clause-84-6",
              "type": "clause",
              "marker": "84.",
              "level": "main",
              "text": "Countries could consider mechanisms for legal arrangements to have unique identifying elements facilitating their unequivocal identification. In some countries, there may be limitations on using and sharing tax or other identifiers or trusts and similar legal arrangements may not have tax identifiers. In such cases, it may be appropriate to consider developing alternative mechanisms or procedures to ensure legal arrangements can be identified.",
              "children": []
            },
            {
              "id": "clause-85-7",
              "type": "clause",
              "marker": "85.",
              "level": "main",
              "text": "The trust’s written instrument (trust deed) is an expression of the terms of the trust and can set out who the parties to the trust or similar legal arrangement are, as well as their rights and obligations. It can also include the rationale behind the formation of a trust which contributes to the understanding of its purpose. In addition, certain rights and obligations, such as determining beneficiaries and the purpose, may also be set out in other documents accompanying the trust’s written instrument (e.g., a side letter to the trust deed or a letter of wishes). Where the parties to the trust or other similar legal arrangement are other legal persons or arrangements, the INR.25 outlines that countries should require trustees and persons holding an equivalent position in a similar legal arrangement to also obtain and hold adequate, accurate, and up-to-date basic and beneficial ownership information of the legal persons or arrangements (see INR.25.1). The basic information of the legal persons is described in INR.24.4.",
              "children": []
            },
            {
              "id": "subheading-adequate-beneficial-ownership-information-8",
              "type": "subheading",
              "text": "4.2 Adequate beneficial ownership information",
              "subsectionIndex": 1
            },
            {
              "id": "clause-83-9",
              "type": "clause",
              "marker": "83.",
              "level": "main",
              "text": "Countries should have mechanisms in place that ensure beneficial ownership information on trusts and other similar legal arrangements is adequate. Adequate information is data that is sufficient to identify the natural persons who are the beneficial owner(s), and their role in the legal arrangement. Where the trustee (or person holding an equivalent position in a similar legal arrangement) and any other party to the trust (or legal arrangement) is a legal person or legal arrangement, the beneficial owner of that legal person or legal arrangement should be identified in accordance with the methods specified in relation to R.24 and R.25.",
              "children": []
            },
            {
              "id": "clause-84-10",
              "type": "clause",
              "marker": "84.",
              "level": "main",
              "text": "The requirement to obtain adequate information specifically concerns “trustees of any express trust and persons holding an equivalent position in a similar legal arrangement, that are residents in their country or that administer any express trusts or similar legal arrangements in their country” (as per the INR.25).",
              "children": []
            },
            {
              "id": "clause-85-11",
              "type": "clause",
              "marker": "85.",
              "level": "main",
              "text": "The trust instrument or equivalent document for other legal arrangements should be the primary source for information on trust parties. While it would be expected that the adequate information about the trust is included in the trust deed, some information may be included in other documents accompanying the trust deed.",
              "children": []
            },
            {
              "id": "clause-86-12",
              "type": "clause",
              "marker": "86.",
              "level": "main",
              "text": "As per INR.24, examples of information aimed at identifying the natural person(s) who are the beneficial owner(s) include the full name, nationality(ies), the full date and place of birth, residential address, national identification number and document type, and the tax identification number or equivalent in the country of residence.",
              "children": []
            },
            {
              "id": "clause-87-13",
              "type": "clause",
              "marker": "87.",
              "level": "main",
              "text": "The information obtained on the role of the beneficial owner in the legal arrangement must make clear whether this beneficial owner is the settlor, trustee, protector, beneficiary, or a natural person exercising ultimate effective control over the trust (see para. 38).",
              "children": []
            },
            {
              "id": "clause-88-14",
              "type": "clause",
              "marker": "88.",
              "level": "main",
              "text": "Where parties to the trust are legal persons or arrangements, information on these parties should include the information on their beneficial owners, including the means and mechanisms through which the beneficial owner exercises beneficial ownership and the scope of their beneficial interest in the legal person or arrangement. Other information that may be useful could include information on legal intermediaries or legal entities involved in the chain.",
              "children": []
            },
            {
              "id": "clause-89-15",
              "type": "clause",
              "marker": "89.",
              "level": "main",
              "text": "As stated in INR.25, and further to the risk-based approach, trustees and their equivalents are not expected to obtain fully adequate and accurate information on the beneficiary(ies) of trusts/similar legal arrangement which are designated by characteristics or by class until the person becomes entitled as beneficiary at the time of payout or when the beneficiary intends to exercise vested rights. In such cases, the trustee is expected to obtain and hold information that clearly identifies the characteristics or class of beneficiaries. However, when the beneficiary(ies) becomes entitled, the trustee should obtain and hold information on their identity. Countries may also decide that it is not necessary to identify the individual beneficiaries of certain charitable or statutory permitted non-charitable trusts. This decision should be based on a risk assessment of this type of trusts and should clearly align with the findings of that risk assessment.",
              "children": []
            },
            {
              "id": "clause-90-16",
              "type": "clause",
              "marker": "90.",
              "level": "main",
              "text": "Trustees may take a risk-based approach to determine the details of information that they should hold about objects of a power. For instance, where the class of objects is very broad it may be appropriate to hold information about the characteristics of a class that would allow the trustee to accurately determinate and identify whether any specified beneficiary is a member of the class.",
              "children": []
            },
            {
              "id": "clause-91-17",
              "type": "clause",
              "marker": "91.",
              "level": "main",
              "text": "Where individuals are identified as objects of a power, the trustee should obtain and hold, as a minimum, sufficient details to be able to identify and verify the identity of such individual in the event that a discretion or power is to be exercised by the trustee in favour of such object of power, resulting in the identification of a beneficiary.",
              "children": []
            },
            {
              "id": "clause-92-18",
              "type": "clause",
              "marker": "92.",
              "level": "main",
              "text": "It is not mandatory to obtain official identity documentation as the object of a power might not be yet aware of the existence of the trust itself. In such a case, verification measures that can be deployed on a risk sensitive basis include:",
              "children": []
            },
            {
              "id": "clause-92-18-verification-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "obtaining a declaration confirming the identification details of the object of a power from the settlor (in the case of trustees);",
              "children": []
            },
            {
              "id": "clause-92-18-verification-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "relying on any identification details that might be available in a trust deed, letter of wishes or similar document; or",
              "children": []
            },
            {
              "id": "clause-92-18-verification-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "verifying the information from publicly available sources or accessible registries.",
              "children": []
            },
            {
              "id": "subheading-accurate-beneficial-ownership-information-19",
              "type": "subheading",
              "text": "4.3 Accurate beneficial ownership information",
              "subsectionIndex": 2
            },
            {
              "id": "clause-93-20",
              "type": "clause",
              "marker": "93.",
              "level": "main",
              "text": "Countries may adopt different verification mechanisms at the various stages (as outlined below) to ensure that the beneficial ownership information is accurate (INR.25 paragraph 6).",
              "children": []
            },
            {
              "id": "clause-94-21",
              "type": "clause",
              "marker": "94.",
              "level": "main",
              "text": "Verifying beneficial ownership information could involve a review of documents submitted (e.g., trust instrument and any other document identifying beneficial owners, such as letters of wishes etc.). Verifying beneficial ownership information could also include, depending on the level of risk and the person conducting the verification (e.g., trustees or authorities), use of government-issued identity documents, and cross-checks with relevant government and other available databases (e.g., bank account registries, population or national identity registers, taxpayers’ identification register, vehicles, and land registries).",
              "children": []
            },
            {
              "id": "clause-95-22",
              "type": "clause",
              "marker": "95.",
              "level": "main",
              "text": "Verification of beneficial owner’s identities may take place during various stages or processes, depending on the approach to holding beneficial ownership information followed in each country. The chosen approach could include means of verification such as:",
              "children": []
            },
            {
              "id": "clause-95-22-verification-means-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "By trustees and persons holding an equivalent position in a similar legal arrangement, in any cases.",
              "children": []
            },
            {
              "id": "clause-95-22-verification-means-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "By authority(ies) or body(ies) responsible for recording information on the beneficial ownership of trusts or other similar legal arrangements in cases in which a registry is set up.",
              "children": []
            },
            {
              "id": "clause-95-22-verification-means-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "By other authority(ies) that hold or obtain information on trust/similar legal arrangements and trustees/their equivalent.",
              "children": []
            },
            {
              "id": "clause-95-22-verification-means-3",
              "type": "clause",
              "marker": "d.",
              "level": "nested",
              "text": "By agents and service providers, including trust and company service providers, investment advisors, lawyers, accountants or FIs when they are creating, operating or managing a legal arrangement as well as FIs in the context of CDD according to R. 10 and DNFBPs in the context of CDD according to R. 22.",
              "children": []
            },
            {
              "id": "clause-96-23",
              "type": "clause",
              "marker": "96.",
              "level": "main",
              "text": "Whereas the means of verification may vary on the basis of risk, context, and materiality, it is important that the criteria for finding out and verifying the identity of a beneficial owner are, in any case, consistent with relevant applicable requirements (in particular those applied to CDD pursuant to R. 10 or 22). Verification should be of the following two aspects:",
              "children": []
            },
            {
              "id": "clause-96-23-verification-aspect-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "Verification of identity: Appropriate steps should be taken to verify the identity of any natural person(s) recorded as a beneficial owner.",
              "children": []
            },
            {
              "id": "clause-96-23-verification-aspect-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "Verification of status: Appropriate steps should be taken to verify the basis of identification of a person as a beneficial owner.",
              "children": []
            },
            {
              "id": "clause-97-24",
              "type": "clause",
              "marker": "97.",
              "level": "main",
              "text": "The goal is to reduce the risks of inaccurate information and allow enforcement of beneficial ownership transparency rules. However, this does not imply a zero-failure approach. It is a process aimed at increasing confidence that information is reliable, and that obvious errors, falsehoods or inconsistencies are spotted and corrected systematically. Countries may consider automated checks where possible to minimise the burden of verification and increase the timeliness of processing.",
              "children": []
            },
            {
              "id": "clause-98-25",
              "type": "clause",
              "marker": "98.",
              "level": "main",
              "text": "Countries may adopt a risk-based approach to verification. In cases of higher risk (e.g., legal arrangements with complex structures across multiple countries, legal arrangements identified as high-risk in a risk assessment, legal arrangements with a history of reporting inaccurate beneficial ownership information, or where sufficient documentation may not be obtained), the extent and/or frequency of verification measures should be enhanced.",
              "children": []
            },
            {
              "id": "clause-99-26",
              "type": "clause",
              "marker": "99.",
              "level": "main",
              "text": "Subject to the approach set out in paragraph 95 above, information might be verified:",
              "children": []
            },
            {
              "id": "clause-100-27",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "when a trust is first established.",
              "children": []
            },
            {
              "id": "clause-101-28",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "when a trust is registered.",
              "children": []
            },
            {
              "id": "clause-102-29",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "when a change happens (e.g., a change in trustee).",
              "children": []
            },
            {
              "id": "clause-103-30",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "when the identity of an entity becomes apparent (e.g., when an object in a class becomes entitled to an amount or where an ultimate controller is identified).",
              "children": []
            },
            {
              "id": "clause-104-31",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "when a trust enters an arrangement with a financial institution or government body (such as opening a bank account, purchasing real property or lodging a tax return).",
              "children": []
            },
            {
              "id": "clause-105-32",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "when an automated exchange of information with reliable national systems occurs the frequency of which will depend on a risk-based approach.",
              "children": []
            },
            {
              "id": "clause-106-33",
              "type": "clause",
              "marker": "100.",
              "level": "main",
              "text": "In the case of an ongoing relationship, it may be appropriate to check that information continues to be accurate. The frequency of such checks will depend on a risk assessment including factors such as:",
              "children": []
            },
            {
              "id": "clause-107-34",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the frequency and value of transactions or dealings.",
              "children": []
            },
            {
              "id": "clause-108-35",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the significance of the information in terms of addressing ML/TF risks.",
              "children": []
            },
            {
              "id": "clause-109-36",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the likelihood of information changing.",
              "children": []
            },
            {
              "id": "clause-110-37",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "other relevant legal obligations and checks.",
              "children": []
            },
            {
              "id": "clause-111-38",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the ease of verifying the information.",
              "children": []
            },
            {
              "id": "clause-112-39",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the source and value of the assets settled in trust.",
              "children": []
            },
            {
              "id": "clause-113-40",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the country of origin, country of residence of the settlor, protector and other parties including the object of a power.",
              "children": []
            },
            {
              "id": "clause-114-41",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the status of the object of a power or any other party (e.g., whether he/she is a PEP or other high-risk customer).",
              "children": []
            },
            {
              "id": "clause-115-42",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "complexity of the structure.",
              "children": []
            },
            {
              "id": "clause-116-43",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "the purpose of the settling of property in trust.",
              "children": []
            },
            {
              "id": "clause-117-44",
              "type": "clause",
              "marker": "117.",
              "level": "main",
              "text": "Enhanced verification mechanisms can also be used to detect inaccuracies in beneficial ownership information and/or deliberate concealment, such as undisclosed nominee relationships. Such checks of a more investigative nature may be conducted by law enforcement authorities. In countries which require engagement of a professional intermediary for the setting up of trusts or similar legal arrangements, regulated professional intermediaries could be required to perform such enhanced checks. Examples of mechanisms to identify inaccuracies are provided in Box 4.1",
              "children": []
            },
            {
              "id": "content-box-box-4-1-mechanisms-to-identify-and-mitigate-inaccuracies-45",
              "type": "contentBox",
              "title": "Box 4.1. Mechanisms to identify and mitigate inaccuracies",
              "text": "Box 4.1. Mechanisms to identify and mitigate inaccuracies To allow for the verification of information, countries may consider mechanisms that allow: Access by reporting entities to information so that it may be used, for example, to complement CDD obligations. Adjudicating discrepancy reports and feedback system: If reliant on a registry, countries may consider implementing a system to review and adjudicate discrepancy reports fairly and efficiently, emphasising due process and a risk-based approach. Trustees and persons holding equivalent positions in other legal arrangements should be informed at the appropriate time of the reported discrepancies (with reasons) so that data can be rectified in a timely manner (whilst avoiding tipping off, where applicable). Upon resolving a difference, countries should consider notifying the reporting entity to align all information. Record-keeping: Countries should consider properly recording information so that potential users of this information are aware that this data might not be adequate, accurate, or up to date. Privacy considerations should be considered along with data privacy laws, client confidentiality, and other relevant concerns. For instance, safeguards should be made to prevent data leakage.",
              "blocks": [
                {
                  "id": "paragraph--0",
                  "type": "paragraph",
                  "text": "To allow for the verification of information, countries may consider mechanisms that allow:"
                },
                {
                  "id": "clause--1",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Access by reporting entities to information so that it may be used, for example, to complement CDD obligations.",
                  "children": []
                },
                {
                  "id": "clause--2",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Adjudicating discrepancy reports and feedback system: If reliant on a registry, countries may consider implementing a system to review and adjudicate discrepancy reports fairly and efficiently, emphasising due process and a risk-based approach. Trustees and persons holding equivalent positions in other legal arrangements should be informed at the appropriate time of the reported discrepancies (with reasons) so that data can be rectified in a timely manner (whilst avoiding tipping off, where applicable). Upon resolving a difference, countries should consider notifying the reporting entity to align all information.",
                  "children": []
                },
                {
                  "id": "clause--3",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Record-keeping: Countries should consider properly recording information so that potential users of this information are aware that this data might not be adequate, accurate, or up to date.",
                  "children": []
                },
                {
                  "id": "paragraph--4",
                  "type": "paragraph",
                  "text": "Privacy considerations should be considered along with data privacy laws, client confidentiality, and other relevant concerns. For instance, safeguards should be made to prevent data leakage."
                }
              ]
            },
            {
              "id": "clause-102-46",
              "type": "clause",
              "marker": "102.",
              "level": "main",
              "text": "Regardless of the mechanisms used, countries may also require a declaration that the information disclosed at the time of submission is truthful and complete. 21 While the declaration would put the primary burden of providing truthful information on the party(ies) making the submission, this should not replace the various verification efforts by the person receiving the information. The applicable legal framework should also provide for dissuasive sanctions to be applied where it is established that a false or inaccurate declaration has been provided.",
              "children": []
            },
            {
              "id": "clause-103-47",
              "type": "clause",
              "marker": "103.",
              "level": "main",
              "text": "Countries may consider establishing an obligation on the parties and beneficial owners of the trusts to provide the trustee, upon request or spontaneously, with any relevant information to ensure the accuracy of the information, as well as enduring the information is up to date.",
              "children": []
            },
            {
              "id": "clause-103-47-verification-identity-heading",
              "type": "inlineHeading",
              "text": "Verification of identity of the beneficial owner"
            },
            {
              "id": "clause-104-48",
              "type": "clause",
              "marker": "104.",
              "level": "main",
              "text": "In the identity verification processes, appropriate steps should be taken to prove that a natural person, who has been identified as a beneficial owner, exists and is who they claim to be, e.g., by reviewing government-issued identity documents or other reliable documents or information. An identity is a combination of “attributes” that belong to a person, e.g., name, date of birth, and nationality. For example, in the case of registries, such verification could be done by an automated data exchange with a reliable national system such as a residence register, tax register, passport database or electoral information, bank account registries, and other population and vehicle or land registries if such an exchange provides the same level of assurance.",
              "children": []
            },
            {
              "id": "clause-105-49",
              "type": "clause",
              "marker": "105.",
              "level": "main",
              "text": "When verifying a person’s identity, the robustness of the evidence must be considered. This relates to the amount and reliability of source data, documents, or information provided, and a risk-based approach should apply. For verifying the identity of a beneficial owner located abroad, the receiving end of beneficial ownership information should take steps to verify the authenticity of legal documentation provided from abroad.",
              "children": []
            },
            {
              "id": "clause-106-50",
              "type": "clause",
              "marker": "106.",
              "level": "main",
              "text": "Identity information is considered accurate where it is verified using reliable documents, data, or information. The type and extent of verification measures are to be determined based on the level of risk posed by the business relationship or occasional transaction being carried out. Level of risk is based on various elements including but not restricted to:",
              "children": []
            },
            {
              "id": "clause-106-50-identity-risk-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "the source and value of the assets settled in trust.",
              "children": []
            },
            {
              "id": "clause-106-50-identity-risk-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "the country of origin, country of residence of the settlor, protector and other parties including any object of a power.",
              "children": []
            },
            {
              "id": "clause-106-50-identity-risk-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "the status of the object of a power or any other party (e.g., whether he/she is a PEP or other high-risk customer).",
              "children": []
            },
            {
              "id": "clause-106-50-identity-risk-3",
              "type": "clause",
              "marker": "d.",
              "level": "nested",
              "text": "complexity of the structure.",
              "children": []
            },
            {
              "id": "clause-106-50-identity-risk-4",
              "type": "clause",
              "marker": "e.",
              "level": "nested",
              "text": "the purpose of the settling of property in trust, if known.",
              "children": []
            },
            {
              "id": "paragraph--51",
              "type": "inlineHeading",
              "text": "Verification of status of the beneficial owner"
            },
            {
              "id": "clause-107-52",
              "type": "clause",
              "marker": "107.",
              "level": "main",
              "text": "Depending on the level of risk, verification of the status of the beneficial owner includes but is not limited to the following elements:",
              "children": []
            },
            {
              "id": "clause-107-52-status-risk-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "Does the person identified as the beneficial owner meet the definition of a beneficial owner of the trust or the similar legal arrangement? i.e., is the person identified as beneficial owner the settlor/trustee/protector/beneficiary or object of a power of the trust/similar legal arrangement?",
              "children": []
            },
            {
              "id": "clause-107-52-status-risk-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "Are there any other persons who can exercise ultimate effective control over the trust? Is the settlor or any of the beneficiaries acting as a nominee?",
              "children": []
            },
            {
              "id": "clause-107-52-status-risk-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "Are there any legal persons/arrangements among the parties of the trust/similar legal arrangements? If so, have the natural persons who are their beneficial owners been identified?",
              "children": []
            },
            {
              "id": "clause-107-52-status-risk-3",
              "type": "clause",
              "marker": "d.",
              "level": "nested",
              "text": "Are there any nominee arrangements involving parties to the trust/similar legal arrangements? If so, have the natural person who is the nominator (or its beneficial owners if the nomination is a legal person/arrangement) been identified?",
              "children": []
            },
            {
              "id": "clause-108-53",
              "type": "clause",
              "marker": "108.",
              "level": "main",
              "text": "As the status of a beneficial owner may change over time, countries may consider requiring that the information be verified where it is updated (instead of simply relying on the checks carried out at the point when the trust is formed and/or information filed to a registry). The historical data collected over time could also be useful to national authorities, FIs, or DNFBPs. Up-to-date beneficial ownership information 22",
              "children": []
            },
            {
              "id": "clause-109-54",
              "type": "clause",
              "marker": "109.",
              "level": "main",
              "text": "Countries should require trustees and persons holding an equivalent position in similar legal arrangements to obtain and hold up-to-date beneficial ownership information and that such information is available to and competent authorities. Countries should also consider measures to facilitate access to such information by FIs and DNFBPs undertaking the requirements in R.10 and R.22.",
              "children": []
            },
            {
              "id": "clause-110-55",
              "type": "clause",
              "marker": "110.",
              "level": "main",
              "text": "As a best practice to ensure that information is up-to-date, countries may consider requiring periodical validation of the beneficial ownership information on a risk-based approach, such as by reviewing or verifying the information. Such regular validation could be considered for trustees or their equivalents, as well as for other mechanisms used to ensure that FIs, DNFBPs and competent authorities have access to such information. Regular validation processes could contribute to uncovering changes in the beneficial ownership and would be useful if a trustee or equivalent inadvertently fails to identify and report these changes.",
              "children": []
            },
            {
              "id": "clause-111-56",
              "type": "clause",
              "marker": "111.",
              "level": "main",
              "text": "In the case of legal arrangements, specific events which may warrant updating of information within the ‘reasonable timeframe’ include when beneficiaries previously identified by class or characteristics become ascertainable due to, for example, the expiration of an accumulation period or the trustee of a discretionary trust exercising their discretionary powers to determine who the beneficiaries shall be.",
              "children": []
            },
            {
              "id": "clause-112-57",
              "type": "clause",
              "marker": "112.",
              "level": "main",
              "text": "When there are changes to any of the basic and beneficial ownership information of trusts or similar legal arrangements (e.g., addition of new beneficiaries, appointment of co-trustees or protectors, or changes to identity details of current parties), trustees are expected to obtain and verify this information within a reasonable time from when the change occurs. In addition, depending on the mechanism used by the country to ensure that competent authorities can access up- to-date information, countries should have mechanisms in place to ensure that the information is updated within a reasonable timeframe.",
              "children": []
            },
            {
              "id": "clause-113-58",
              "type": "clause",
              "marker": "113.",
              "level": "main",
              "text": "It can be considered that a reasonable time to update information may be shorter in cases where such changes are occasioned by the trustee himself (e.g. the trustee exercises his power to appoint a beneficiary, or the trustee identifies a person as an object of a power) or when the trustee becomes immediately aware of such changes (e.g., the amendment clause of a trust deed requires any amendments to occur with the trustee’s approval). It is straightforward for the trustee to detect such changes and obtain and verify the updated information expected to take place within a reasonable period. While this is considered to be the norm (i.e., for trustees to be immediately aware of any changes to the trust or its parties), this might not always be the case, for example when such changes are not reported but identified later or not reported in a timely manner to trustees.",
              "children": []
            },
            {
              "id": "clause-114-59",
              "type": "clause",
              "marker": "114.",
              "level": "main",
              "text": "In other cases, to ensure that the basic and beneficial ownership remains up to date, trustees are expected to conduct periodic reviews to detect any updates. The periodicity is to be determined based on ML/TF risk. Trustees are also expected to conduct a review upon the occurrence of trigger events (e.g., payout of significant amounts, receiving instructions from a newly appointed protector, settlement of additional assets in trust).",
              "children": []
            },
            {
              "id": "clause-115-60",
              "type": "clause",
              "marker": "115.",
              "level": "main",
              "text": "Countries should ensure that trustees retain beneficial ownership records for at least five years after their involvement with the trust or legal arrangement ceases. These record-keeping timeframes set out a minimum requirement. Trustees may thus, in order to adhere to other legal requirements or manage liability, keep records for more extended periods. For instance, lengthier record-keeping requirements may emanate from trust law or may be necessary to render account of one’s actions as trustee.",
              "children": []
            }
          ]
        },
        {
          "number": "5",
          "label": "Section 5",
          "title": "Mechanisms and sources for obtaining beneficial ownership information",
          "hideLabel": false,
          "body": "",
          "blocks": [
            {
              "id": "clause-116-0",
              "type": "clause",
              "marker": "116.",
              "level": "main",
              "text": "Countries should ensure that adequate, accurate, and up-to-date information on the basic and beneficial ownership of the trusts or other similar legal arrangements, trustees and trust assets, is accessible efficiently and in a timely manner by competent authorities. In this regard, other than through trustees or equivalent, countries should consider, on the basis of risk, context and materiality, using any of the following sources of information as necessary (see INR.25.5):",
              "children": []
            },
            {
              "id": "clause-116-0-information-source-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "A public authority or body holding information on the beneficial ownership of trusts or other similar arrangements (e.g., in a central registry of trusts; or in asset registries for land, property, vehicles, shares or other assets that hold information on the beneficial ownership of trusts and other similar legal arrangements, which own such assets). Information need not be held by a single body only.",
              "children": []
            },
            {
              "id": "clause-116-0-information-source-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "Other competent authorities that hold or obtain information on trusts/similar legal arrangements and trustees/their equivalents (e.g., tax authorities, which collect information on assets and income relating to trusts and other similar legal arrangements) provided that this information is accessible according to internationally agreed standards.",
              "children": []
            },
            {
              "id": "clause-116-0-information-source-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "Other agents or service providers, including trust and company service providers, investment advisors or managers, accountants, lawyers, or financial institutions.",
              "children": []
            },
            {
              "id": "clause-117-1",
              "type": "clause",
              "marker": "117.",
              "level": "main",
              "text": "Box 5.1 below further includes examples of mechanisms to access information, including some which are mandatory in line with standards.",
              "children": []
            },
            {
              "id": "content-box-box-5-1-mechanisms-to-ensure-the-availability-of-beneficial-ownership-information-2",
              "type": "contentBox",
              "title": "Box 5.1. Mechanisms to ensure the availability of beneficial ownership information",
              "text": "Box 5.1. Mechanisms to ensure the availability of beneficial ownership information Trustees are required to obtain and hold information on the trustee, the settlor, the protector (if any), the beneficiaries or class of beneficiaries, object of a power, and any other person exercising control over the trust. Trustees could hold the information in electronic form, to ensure that they can provide such information to competent authorities upon request, in a timely manner. The obligations on trustees are supervised and enforced by a competent authority and trustees are subject to dissuasive and proportionate sanctions for failure to hold the required information, or for failing to grant to competent authorities’ timely access to information regarding the trust. Trustees of express trusts are required to disclose their status to financial institutions. Sanctions apply for the provision of false information such as administrative penalties. TCSPs, lawyers and accountants carry out CDD and understand their CDD obligations with respect to beneficial ownership, and are subject to AML/CFT supervision, in line with R.10. Other competent authorities may hold or obtain information on trusts and trustees (e.g., tax authorities, which collect information on assets and income relating to trusts and other similar legal arrangements). A country could establish a central registry of trusts which includes information on (i) the settlor(s), (ii) the trustee(s), (iii) the protectors (if any); (iv) each beneficiary(ies) or, where applicable, the class of beneficiaries and objects of a power, and (v) any other natural person(s) exercising ultimate effective control over the trust.",
              "blocks": [
                {
                  "id": "clause--0",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Trustees are required to obtain and hold information on the trustee, the settlor, the protector (if any), the beneficiaries or class of beneficiaries, object of a power, and any other person exercising control over the trust.",
                  "children": []
                },
                {
                  "id": "clause--1",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Trustees could hold the information in electronic form, to ensure that they can provide such information to competent authorities upon request, in a timely manner.",
                  "children": []
                },
                {
                  "id": "clause--2",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "The obligations on trustees are supervised and enforced by a competent authority and trustees are subject to dissuasive and proportionate sanctions for failure to hold the required information, or for failing to grant to competent authorities’ timely access to information regarding the trust.",
                  "children": []
                },
                {
                  "id": "clause--3",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Trustees of express trusts are required to disclose their status to financial institutions. Sanctions apply for the provision of false information such as administrative penalties.",
                  "children": []
                },
                {
                  "id": "clause--4",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "TCSPs, lawyers and accountants carry out CDD and understand their CDD obligations with respect to beneficial ownership, and are subject to AML/CFT supervision, in line with R.10.",
                  "children": []
                },
                {
                  "id": "clause--5",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "Other competent authorities may hold or obtain information on trusts and trustees (e.g., tax authorities, which collect information on assets and income relating to trusts and other similar legal arrangements).",
                  "children": []
                },
                {
                  "id": "clause--6",
                  "type": "clause",
                  "marker": "•",
                  "level": "main",
                  "text": "A country could establish a central registry of trusts which includes information on (i) the settlor(s), (ii) the trustee(s), (iii) the protectors (if any); (iv) each beneficiary(ies) or, where applicable, the class of beneficiaries and objects of a power, and (v) any other natural person(s) exercising ultimate effective control over the trust.",
                  "children": []
                }
              ]
            },
            {
              "id": "subheading-trustees-3",
              "type": "subheading",
              "text": "5.1 Trustees",
              "subsectionIndex": 0
            },
            {
              "id": "clause-118-4",
              "type": "clause",
              "marker": "118.",
              "level": "main",
              "text": "Countries should require trustees of any express trust and persons holding an equivalent position in a similar legal arrangement, who are residents in their country or administer any express trusts or similar legal arrangements in their country, to obtain and hold adequate, accurate, and up-to-date beneficial ownership information regarding the trust or similar legal arrangement.",
              "children": []
            },
            {
              "id": "clause-119-5",
              "type": "clause",
              "marker": "119.",
              "level": "main",
              "text": "Below are some examples to be read in conjunction with other general considerations covered under the Guidance to R.24, relevant for determining the beneficial owner of a trust:",
              "children": []
            },
            {
              "id": "clause-119-5-trust-example-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "A good understanding and knowledge of trust principles and trusts law may be necessary to determine the beneficial owner of a complex trust/legal arrangement structure, as well as a good understanding of certain specific nuances of trust law or law governing other legal arrangements in different countries.",
              "children": []
            },
            {
              "id": "clause-119-5-trust-example-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "Similarly, understanding the flexibility and different types of trusts/legal arrangements might be instrumental to being able to determine whether any other person is exercising effective control over the trust.",
              "children": []
            },
            {
              "id": "subheading-the-registry-approach-6",
              "type": "subheading",
              "text": "5.2 The registry approach",
              "subsectionIndex": 1
            },
            {
              "id": "clause-120-7",
              "type": "clause",
              "marker": "120.",
              "level": "main",
              "text": "The “registry approach” envisaged as one of the sources of beneficial ownership information on legal persons under R.24, may also be considered in relation to trusts and other legal arrangements under R.25. While such consideration needs to be made considering risk, context, and materiality of a given country, it would potentially provide for an additional source of information to the default rule under R.25 that beneficial ownership information be collected and maintained by trustees or persons holding an equivalent position in a similar legal arrangement. It could therefore be one of the ways to ensure that competent authorities have timely access to adequate, accurate, and up-to-date information on the beneficial ownership of trusts and other legal arrangements under R. 25.",
              "children": []
            },
            {
              "id": "clause-121-8",
              "type": "clause",
              "marker": "121.",
              "level": "main",
              "text": "Some countries may opt to hold one register of beneficial ownership for both legal persons as well as trusts and/or other legal arrangements. This may be the case for countries which do not give legal recognition to trusts under their legislation, although this is not always necessarily the case. Some countries may also opt to set up different registers for trusts and other legal arrangements reflecting the different nature of trusts and other legal arrangements.",
              "children": []
            },
            {
              "id": "clause-122-9",
              "type": "clause",
              "marker": "122.",
              "level": "main",
              "text": "Countries which opt to maintain registers may cover all express trusts and similar legal arrangements which are administered in their country or for which the trustee or equivalent resides in the country. The registers may also consider covering foreign trusts and similar legal arrangements with sufficient links with the country, if the risk assessment has shown major risks that require covering these legal arrangements.",
              "children": []
            },
            {
              "id": "clause-123-10",
              "type": "clause",
              "marker": "123.",
              "level": "main",
              "text": "Countries that make use of a public authority or body holding beneficial ownership information should consider the resources and expertise that will be required to maintain the register, and to ensure that the information recorded in the register is adequate, accurate and up-to-date, and can be accessed in a timely and efficient manner.",
              "children": []
            },
            {
              "id": "clause-124-11",
              "type": "clause",
              "marker": "124.",
              "level": "main",
              "text": "A mechanism that provides for a public authority or body holding beneficial ownership information could include some or all of the following features. These are to be read in conjunction with other general considerations covered under the Guidance to R.24:",
              "children": []
            },
            {
              "id": "clause-125-12",
              "type": "clause",
              "marker": "125.",
              "level": "main",
              "text": "Trustees or equivalent are required to provide beneficial ownership information to the authority/body administering the beneficial ownership register of trusts.",
              "children": []
            },
            {
              "id": "clause-126-13",
              "type": "clause",
              "marker": "126.",
              "level": "main",
              "text": "Trustees or equivalent are required to update beneficial ownership information regularly and within a reasonable period following any change.",
              "children": []
            },
            {
              "id": "clause-127-14",
              "type": "clause",
              "marker": "127.",
              "level": "main",
              "text": "Trustees or equivalent may be required by countries, following a risk-based approach, to make a declaration (e.g., sworn statement) regarding the beneficial owner and the ownership structure. This could include the provision of copies of documentation for the verification of identity.",
              "children": []
            },
            {
              "id": "clause-128-15",
              "type": "clause",
              "marker": "128.",
              "level": "main",
              "text": "The public authority or body holding beneficial ownership information is required, on a risk-based approach, to establish different mechanisms to verify the identity of the beneficial owners and that they indeed satisfy the criteria for being regarded as beneficial owners.",
              "children": []
            },
            {
              "id": "clause-129-16",
              "type": "clause",
              "marker": "129.",
              "level": "main",
              "text": "The public authority or body holding beneficial ownership information is empowered to impose, and effectively applies, proportionate and dissuasive sanctions on trustees or equivalent that fail to provide beneficial ownership information.",
              "children": []
            },
            {
              "id": "clause-130-17",
              "type": "clause",
              "marker": "130.",
              "level": "main",
              "text": "The provision of incorrect information is subject to proportionate and dissuasive administrative and/or criminal sanctions. A director of a trust company or any other person entrusted with the management and administration thereof could also be held personally liable.",
              "children": []
            },
            {
              "id": "clause-131-18",
              "type": "clause",
              "marker": "131.",
              "level": "main",
              "text": "The public authority or body holding beneficial ownership information regularly applies such sanctions when obligations are breached or reports breaches to the appropriate authority, including the filing of any suspicious reports to the appropriate authority if this is deemed necessary in the context.",
              "children": []
            },
            {
              "id": "clause-132-19",
              "type": "clause",
              "marker": "132.",
              "level": "main",
              "text": "The public authority or body holding beneficial ownership information takes a proactive role, including checking information against other sources (such as data collected through regulatory submissions by professional regulated trustees, asset, tax or national identity registries) through risk-based verification, use of technologies etc., to identify anomalies or inconsistencies and reduce the risk of fraud on supporting documents or improper disclosure.",
              "children": []
            },
            {
              "id": "clause-133-20",
              "type": "clause",
              "marker": "133.",
              "level": "main",
              "text": "FIs and DNFBPs and, if appropriate competent authorities, identify any inaccuracies they find between the beneficial ownership information held by the public authority or other body and the beneficial ownership information available to them. The public authority or body holding beneficial ownership information and/or other relevant authority takes appropriate actions to investigate these inaccuracies and to correct the information within a reasonable timeframe, as may be required.",
              "children": []
            },
            {
              "id": "subheading-other-competent-authorities-21",
              "type": "subheading",
              "text": "5.3 Other competent authorities",
              "subsectionIndex": 2
            },
            {
              "id": "clause-125-22",
              "type": "clause",
              "marker": "125.",
              "level": "main",
              "text": "To enhance information adequacy, accuracy and timeliness, countries may consider whether information on trusts is collected for purposes other than AML/CFT. Countries may also consider approaches to ensure competent authorities have timely access to this information.",
              "children": []
            },
            {
              "id": "clause-126-23",
              "type": "clause",
              "marker": "126.",
              "level": "main",
              "text": "In many countries, tax authorities are the most extensive source of information on the ownership and control of trusts. However, they may only hold information if the trust generates tax liabilities in the jurisdiction. Typically, if a trust receives income above a specific threshold, the trustee must file a tax return with the tax authorities on behalf of the trust. Such a tax return may include information regarding the trustee, the settlor, and each beneficiary with taxable income from the trust in that taxation period. However, not all countries require information on settlors or beneficiaries to be included.",
              "children": []
            },
            {
              "id": "clause-127-24",
              "type": "clause",
              "marker": "127.",
              "level": "main",
              "text": "Some countries have agreements for the automatic exchange of tax information which may provide for greater exchange of information on trusts between different jurisdictions. In particular, through this system, obliged entities (including banks) will report certain beneficial ownership information for tax purposes on an annual basis to a domestic tax authority on a trust that holds an account with the bank and where the beneficiary is resident of a foreign jurisdiction. The domestic tax authority will automatically pass on that information to the foreign jurisdiction’s tax authority. Whether the foreign jurisdiction’s tax authority can pass on this information to other competent authorities must be examined in light of the confidentiality and data safeguards included in the legal instrument providing automatic tax information exchange.",
              "children": []
            },
            {
              "id": "subheading-other-agents-or-service-providers-to-the-trust-25",
              "type": "subheading",
              "text": "5.4 Other agents or service providers to the trust",
              "subsectionIndex": 3
            },
            {
              "id": "clause-128-26",
              "type": "clause",
              "marker": "128.",
              "level": "main",
              "text": "R.10 and R.22 require all FIs (including investment advisors and managers) and DNFBPs (including lawyers, notaries, other independent legal professionals and accountants) to be subject to CDD and record-keeping requirements where they enter a business relationship with or conduct an occasional transaction for a legal arrangement. R.10 and R.22 also apply these requirements to TCSPs when they are acting as (or arranging for another person to act as) a trustee of an express trust or performing the equivalent function for another form of legal arrangement.",
              "children": []
            },
            {
              "id": "clause-129-27",
              "type": "clause",
              "marker": "129.",
              "level": "main",
              "text": "The effect of these requirements is that FIs and DNFBPs that are subject to effective monitoring or supervision and an effective sanctioning regime should hold adequate, accurate, and up to date basic and beneficial ownership information for legal arrangements on an ongoing basis and understand the ownership and control structure of the legal arrangement, along with its business and risk profile.",
              "children": []
            },
            {
              "id": "subheading-access-to-information-28",
              "type": "subheading",
              "text": "5.5 Access to information",
              "subsectionIndex": 4
            },
            {
              "id": "paragraph--29",
              "type": "inlineHeading",
              "text": "Access by competent authorities"
            },
            {
              "id": "clause-130-30",
              "type": "clause",
              "marker": "130.",
              "level": "main",
              "text": "Competent authorities, particularly LEAs and FIUs, should have the powers to access in a timely manner the information held by trustees, persons holding equivalent positions in similar legal arrangements, and other parties, including information held by FIs and DNFBPs on:",
              "children": []
            },
            {
              "id": "clause-130-30-authority-access-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "the basic and beneficial ownership of the legal arrangement; and",
              "children": []
            },
            {
              "id": "clause-130-30-authority-access-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "any assets held or managed by the financial institution or DNFBP, in relation to any trusts or similar legal arrangements with which they have a business relationship, or for which they undertake an occasional transaction.",
              "children": []
            },
            {
              "id": "clause-131-31",
              "type": "clause",
              "marker": "131.",
              "level": "main",
              "text": "Countries should consider using different sources of information as necessary to ensure that adequate, accurate and up-to-date information on the basic and beneficial ownership of the trusts or other similar legal arrangements, trustees and trust assets, is accessible efficiently and in a timely manner by competent authorities, on the basis of risk, context and materiality. 23",
              "children": []
            },
            {
              "id": "clause-132-32",
              "type": "clause",
              "marker": "132.",
              "level": "main",
              "text": "Countries should ensure that a competent authority, such as LEAs and FIUs, has sufficient powers to obtain accurate and up-to-date information, either directly from the party, from an independent third party or a government body. This may include:",
              "children": []
            },
            {
              "id": "clause-132-32-authority-power-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "allowing an LEA or FIU to compel a party to provide them with relevant information or documents (that is, on an individual basis); and",
              "children": []
            },
            {
              "id": "clause-132-32-authority-power-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "requiring a party to an arrangement or other independent party to notify a government body about certain information (for example, changes in ownership).",
              "children": []
            },
            {
              "id": "clause-133-33",
              "type": "clause",
              "marker": "133.",
              "level": "main",
              "text": "Countries should ensure that trustees are not prevented by law from providing competent authorities with relevant information relating to the trust.",
              "children": []
            },
            {
              "id": "clause-134-34",
              "type": "clause",
              "marker": "134.",
              "level": "main",
              "text": "In cases where countries decide to use additional sources of information other than trustees or persons holding an equivalent position in a similar legal arrangement (e.g. public authorities or bodies such as registries, or other persons and entities), competent authorities should have sufficient knowledge of which public authority or body or other person/entity holds adequate, accurate, and up-to-date basic and beneficial ownership information of the trusts or other similar legal arrangements, trustees and trust assets, and how to access that information. When necessary, countries should consider the use of additional sources of information other than trustees or persons holding an equivalent position in a similar legal arrangement (e.g., public authorities or bodies such as registries, or other persons and entities), and ensure competent authorities are aware and able to access these sources.",
              "children": []
            },
            {
              "id": "clause-135-35",
              "type": "clause",
              "marker": "135.",
              "level": "main",
              "text": "The parties that hold relevant information should understand their disclosure obligations, fully co-operate with competent authorities, and provide the information as quickly as possible and within a timeframe which allows authorities to carry out their functions. In implementing this requirement, countries should ensure that there is a clear legal or regulatory framework that authorises such access and disclosure and protects, where necessary, the source(s) of information from liability for authorised disclosures.",
              "children": []
            },
            {
              "id": "clause-135-35-fis-dnfbps-access-heading",
              "type": "inlineHeading",
              "text": "Access by FIs and DNFBPs"
            },
            {
              "id": "clause-136-36",
              "type": "clause",
              "marker": "136.",
              "level": "main",
              "text": "Countries should consider measures to facilitate access by FIs and DNFBPs to information that is held on trusts or other similar legal arrangements by other authorities, persons and entities (e.g., registries) to facilitate compliance with CDD obligations, and support supplementary verification efforts, such as discrepancy reporting, subject to adequate data protection and privacy safeguards.",
              "children": []
            },
            {
              "id": "clause-137-37",
              "type": "clause",
              "marker": "137.",
              "level": "main",
              "text": "Countries should take steps to ensure that trustees or persons holding equivalent positions in similar legal arrangements must disclose their status to FIs and DNFBPs when, in their function, forming a business relationship or carrying out an occasional transaction above the threshold with FIs or DNFBPs. They should also not be prevented by law from providing FIs and DNFBPs, upon request, with information on the beneficial ownership and the assets of the trust or legal arrangement to be held or managed under the terms of the business relationship.",
              "children": []
            },
            {
              "id": "clause-137-37-cost-of-access-heading",
              "type": "inlineHeading",
              "text": "Cost of access"
            },
            {
              "id": "clause-138-38",
              "type": "clause",
              "marker": "138.",
              "level": "main",
              "text": "Where countries choose to hold beneficial ownership information of trusts or other similar arrangements in a registry, 24 they may choose to make access to this information conditional on the payment of a fee. Countries should seek to ensure that such a requirement does not create unnecessary delays or obstacles to efficient and timely access to basic and beneficial ownership information for competent authorities. As a good practice, countries should consider ensuring that competent authorities can access this information free of charge. For FIs and DNFBPs, to help foster the objective of making information sufficiently available, access fees should be proportionate and not exceed the administrative costs for providing such access, including costs of maintenance and future developments of the relevant source of information.",
              "children": []
            }
          ]
        },
        {
          "number": "6",
          "label": "Section 6",
          "title": "Sanctions",
          "hideLabel": false,
          "body": "",
          "blocks": [
            {
              "id": "clause-139-0",
              "type": "clause",
              "marker": "139.",
              "level": "main",
              "text": "Countries should ensure that any requirements to comply with R.25 and its Interpretative Note are clear and unambiguous. This includes that trustees or equivalent persons are either legally liable for any failure to perform the duties relevant to meeting the obligations in paragraphs 1, 4, 8 and 9 of INR.25, or that there are effective, proportionate and dissuasive sanctions for failing to comply. Any sanctions imposed for failing to grant timely access to information regarding the trust to competent authorities should be effective, proportionate, and dissuasive.",
              "children": []
            },
            {
              "id": "clause-140-1",
              "type": "clause",
              "marker": "140.",
              "level": "main",
              "text": "The obligations of trustees and persons holding equivalent positions in a similar legal arrangement should be clearly laid out in written and publicly available rules for legal certainty. Such rules should directly provide for the sanctions for breaches of the obligations corresponding to the requirements of paragraphs 1, 4, 8 and 9 of R.25. It may also be appropriate to impose sanctions on other entities that the country relies on for adequate, accurate and up-to-date basic and beneficial ownership information.",
              "children": []
            },
            {
              "id": "clause-141-2",
              "type": "clause",
              "marker": "141.",
              "level": "main",
              "text": "Where countries decide to require a public authority or body to hold information on the beneficial ownership of trusts or other similar arrangements, they should consider granting this authority or body sufficient powers to ensure that the information they hold is adequate, accurate and up to date, including the power to apply effective, proportionate and dissuasive sanctions. Competent authorities (such as law enforcement authorities and financial intelligence units) empowered to obtain timely access to information held by trustees, persons holding equivalent positions in similar legal arrangements and other parties (e.g., FIs and DNFBPs) should have sanctioning power for failure to provide such information.",
              "children": []
            },
            {
              "id": "clause-142-3",
              "type": "clause",
              "marker": "142.",
              "level": "main",
              "text": "Where countries choose to rely on other sources of beneficial ownership information, they should ensure that there are effective, proportionate and dissuasive sanctions for failure to provide competent authorities with timely access to adequate, accurate and up-to-date information on the basic and beneficial ownership information of the trusts or other similar legal arrangements, trustees and trust assets in an efficient and timely manner.",
              "children": []
            },
            {
              "id": "clause-143-4",
              "type": "clause",
              "marker": "143.",
              "level": "main",
              "text": "Sanctions should apply to both natural and legal persons that fail to comply with the requirements of R.25. Subject to their legal traditions, countries could also attribute liabilities and impose sanctions on legal persons, where breaches of obligations are caused by the intentional or negligent behaviour of the legal person’s senior management, or by persons authorised to act on its behalf within the exercise of their professional functions. In cases of breaches of requirements by employees, liability could also be attributed to the senior management having responsibility over such employees.",
              "children": []
            },
            {
              "id": "clause-144-5",
              "type": "clause",
              "marker": "144.",
              "level": "main",
              "text": "The range of sanctions for breaches of obligation should be effective, proportionate and dissuasive. These can either be administrative, civil, or criminal in nature. Sanctions can be both financial and non-financial. The range of sanctions should be sufficiently broad to capture all responsibilities and possible case scenarios from minor infractions to serious breaches. The sanctions should also be consistent with the seriousness of the breach, and take into account other relevant factors (e.g., systemic and prolonged nature of the breaches). Adequate resources and procedures should be in place that would allow the authority/authorities to ensure effective detection and sanctioning of breaches.",
              "children": []
            }
          ]
        },
        {
          "number": "7",
          "label": "Section 7",
          "title": "Applicability of relevant regulatory regimes and other issues",
          "hideLabel": false,
          "body": "",
          "blocks": [
            {
              "id": "subheading-relevance-of-case-law-precedents-in-meeting-the-obligations-on-trustees-0",
              "type": "subheading",
              "text": "7.1 Relevance of case law precedents in meeting the obligations on trustees",
              "subsectionIndex": 0
            },
            {
              "id": "clause-145-1",
              "type": "clause",
              "marker": "145.",
              "level": "main",
              "text": "The obligations of trustees of express trusts or persons holding equivalent positions in similar legal arrangements may derive from case law.",
              "children": []
            },
            {
              "id": "clause-146-2",
              "type": "clause",
              "marker": "146.",
              "level": "main",
              "text": "The case precedents through which obligations are cast on trustees in common law systems have the nature of binding precedent. The judgements of the court or judicial authority which has pronounced law must have authority in the nature of stare decisis, such that it must be obligatory for subordinate judicial authorities to follow the decision of the superior authority.",
              "children": []
            },
            {
              "id": "subheading-implementation-of-the-standards-by-service-providers-and-trustees-3",
              "type": "subheading",
              "text": "7.2 Implementation of the standards by service providers and trustees",
              "subsectionIndex": 1
            },
            {
              "id": "clause-147-4",
              "type": "clause",
              "marker": "147.",
              "level": "main",
              "text": "The purpose of this section is to provide guidance to service providers and trustees on obtaining beneficial ownership information for express trusts and similar legal arrangements.",
              "children": []
            },
            {
              "id": "clause-147-4-tcsp-heading",
              "type": "inlineHeading",
              "text": "Trust and company service providers (TCSPs)"
            },
            {
              "id": "clause-148-5",
              "type": "clause",
              "marker": "148.",
              "level": "main",
              "text": "TCSPs play an important role in the establishment and administration of legal arrangements. In many countries, trust and company services (such as company formation and management) are offered by a range of different types of entities, including regulated professionals, such as lawyers and accountants. 26 Although lawyers and accountants may be subject to regulation of their primary profession or business in some countries, the provision of trust and company services is one area where criminals may seek to abuse these professions to conceal beneficial ownership information, warranting specific regulatory oversight. 27 In many countries, trust and company services are also offered by other companies that specialise in providing trust and company services, but which may not be regulated in relation to their profession or business. If there is no specific AML/CFT regulation and a designated supervisor, such specialists may be left unregulated. Accordingly, this may increase the AML/CFT risk related to these providers.",
              "children": []
            },
            {
              "id": "clause-149-6",
              "type": "clause",
              "marker": "149.",
              "level": "main",
              "text": "With regard to legal arrangements, TCSPs usually assist in the establishment of those arrangements and act as trustees or are holding equivalent positions in similar legal arrangements. In their capacity as trustees or persons holding equivalent positions of these legal arrangements, TCSPs often represent these legal arrangements in their dealings with other FIs and DNFBPs that are providing for example banking or audit services to these types of customers. 28",
              "children": []
            },
            {
              "id": "clause-150-7",
              "type": "clause",
              "marker": "150.",
              "level": "main",
              "text": "Whenever TCSPs are establishing or administering the legal arrangement or are providing a trustee or of a trust or are holding equivalent positions in similar legal arrangements, they are required under R.10 to understand the general purpose behind the structure and the source of funds in the structure and should be able to identify the beneficial owners. 29 This is in addition to any obligations they will have under R.25.",
              "children": []
            },
            {
              "id": "clause-150-7-legal-profession-heading",
              "type": "inlineHeading",
              "text": "Issues relating to the legal profession"
            },
            {
              "id": "clause-151-8",
              "type": "clause",
              "marker": "151.",
              "level": "main",
              "text": "Whenever the legal profession plays a role in the establishment and administration of legal arrangements, the above expectations for TCSPs would apply to the legal profession. Since the legal profession often acts as trustees, nominees, or both, 30 practical issues relating to legal professional privilege can arise when lawyers have AML/CFT obligations. Indeed, the right of a client to obtain legal representation and advice, be candid with their legal adviser and not fear later disclosure of those discussions to their prejudice is an important feature of the legal profession. 31",
              "children": []
            },
            {
              "id": "clause-152-9",
              "type": "clause",
              "marker": "152.",
              "level": "main",
              "text": "The scope of legal professional privilege and legal professional secrecy is often contained in constitutional law or is recognised by common law and is tied to fundamental rights laid down in treaty or other international obligations 32 and in some federal systems, of each state or province within the country. In addition, the scope of legal professional privilege and legal professional secrecy, and the associated obligations, may also vary across different types of legal professionals within a country and the types of services being offered.",
              "children": []
            },
            {
              "id": "clause-153-10",
              "type": "clause",
              "marker": "153.",
              "level": "main",
              "text": "However, a frequent obstacle to accessing information about some trusts and similar legal arrangements is the use of legal professional privilege and professional secrecy to refuse to divulge information relevant to the ownership and control of trust or other similar legal arrangements. 33",
              "children": []
            },
            {
              "id": "clause-154-11",
              "type": "clause",
              "marker": "154.",
              "level": "main",
              "text": "This is appropriate when such claims are made correctly and in accordance with the law, and where this is tied specifically to legal advice. However, occasionally extremely wide claims of privilege are made that exceed the generally understood provisions of the protections within the relevant country. To help address these issues, competent authorities and professional bodies should work to ensure that there is a clear and shared understanding of the scope of legal professional privilege and legal professional secrecy in their own country. 34",
              "children": []
            },
            {
              "id": "clause-155-12",
              "type": "clause",
              "marker": "155.",
              "level": "main",
              "text": "In particular, countries should seek to ensure that there is a clear understanding of what is, and what is not covered to ensure that investigations involving suspected trusts or other similar legal arrangements are not inappropriately impeded. In addition, countries should be aware that in cases where a legal professional or a legal entity controlled by a legal professional is acting as settlor, beneficiary, controlling person or protector or is holding equivalent positions in similar legal arrangements, a nominee arrangement will often exist. Therefore, more in-depth scrutiny should be applied to identify the actual beneficial owner holding such role.",
              "children": []
            },
            {
              "id": "clause-155-12-non-professional-trustees-heading",
              "type": "inlineHeading",
              "text": "Guidance for non-professional trustees"
            },
            {
              "id": "clause-156-13",
              "type": "clause",
              "marker": "156.",
              "level": "main",
              "text": "Non-professional trustees are commonly appointed in trust for family arrangements, succession, and estate planning. The FATF glossary defines the term “trustee” consistent with Article 2 of the Hague Convention on the law applicable to trusts and their recognition and includes both professional trustees (providing trust services by way of business) as well as trustees who would not be acting as such for profit purposes and/or are not holding themselves out as providing such services to the public and/or on a habitual basis (i.e., non-professional trustees). This means that the obligations under R.25 are applicable to professional and non-professional trustees, including:",
              "children": []
            },
            {
              "id": "clause-157-14",
              "type": "clause",
              "marker": "157.",
              "level": "main",
              "text": "Obtaining and holding adequate, accurate, and up-to-date beneficial ownership information regarding the trust and other similar legal arrangement.",
              "children": []
            },
            {
              "id": "clause-158-15",
              "type": "clause",
              "marker": "158.",
              "level": "main",
              "text": "Disclosing their status as trustees (or equivalent position in other legal arrangements) to FIs and DNFBPs when they seek to form a business relationship or carry out an occasional transaction, and providing them, upon request, information on the beneficial ownership and the assets of the trust or legal arrangement to be held or managed under the terms of the business relationship.",
              "children": []
            },
            {
              "id": "clause-159-16",
              "type": "clause",
              "marker": "159.",
              "level": "main",
              "text": "Providing to competent authorities, upon request, information on the beneficial ownership of, the assets held by it and other information on the trust or similar legal arrangement.",
              "children": []
            },
            {
              "id": "clause-160-17",
              "type": "clause",
              "marker": "160.",
              "level": "main",
              "text": "Maintaining the information on the beneficial owners of the trust or similar legal arrangement for at least five years after their involvement with the trust or similar legal arrangement ceases.",
              "children": []
            },
            {
              "id": "clause-161-18",
              "type": "clause",
              "marker": "161.",
              "level": "main",
              "text": "Maintaining obtained beneficial information up to date, i.e., updating it within a reasonable period following any change.",
              "children": []
            },
            {
              "id": "clause-162-19",
              "type": "clause",
              "marker": "162.",
              "level": "main",
              "text": "Given the non-professional nature of these trustees, supervision and enforcement of these requirements might be more challenging. Countries should consider materiality and risks as well when deciding the extent of the measures that need to be taken on a risk-sensitive basis. Countries could also consider additional measures to mitigate higher risks related to non-professional trustees, such as that non-professional trustees should not settle trust contracts as a business or an obligation for non-professional trustees to maintain a business relationship with FIs and DNFBPs.",
              "children": []
            },
            {
              "id": "clause-163-20",
              "type": "clause",
              "marker": "163.",
              "level": "main",
              "text": "Countries may consider the extent to which their legal framework allows for the adequate oversight or monitoring of non-professional trustees as regards their AML/CFT obligations, following a risk-based approach. Countries may also consider providing guidance and training specific to non-professional trustees on their obligations under R.25.",
              "children": []
            },
            {
              "id": "subheading-the-implementation-of-beneficial-ownership-and-other-fatf-standard-requirements-21",
              "type": "subheading",
              "text": "7.3 The implementation of beneficial ownership and other FATF standard requirements",
              "subsectionIndex": 2
            },
            {
              "id": "paragraph--22",
              "type": "inlineHeading",
              "text": "Aligned interpretation of R.10/22 and R.25"
            },
            {
              "id": "clause-159-23",
              "type": "clause",
              "marker": "159.",
              "level": "main",
              "text": "R.10 and R.22 set out a number of CDD obligations on FIs and DNFBPs, including on professional trustees, which in nature are very close to the ones set out under R.25. By way of example, professional trustees (or equivalent function holders) are required to identify and verify the beneficial owners of trusts or similar legal arrangements they administer in terms of R.22. This entails obtaining adequate, accurate, and up-to-date beneficial ownership information regarding the trust or legal arrangement.",
              "children": []
            },
            {
              "id": "clause-160-24",
              "type": "clause",
              "marker": "160.",
              "level": "main",
              "text": "Information on trusts and similar legal arrangements collected by FIs and DNFBPs, as part of CDD can be one source of information – as noted under para. 5 of the INR.25.",
              "children": []
            },
            {
              "id": "clause-161-25",
              "type": "clause",
              "marker": "161.",
              "level": "main",
              "text": "Under R.10 and R.22, FIs and DNFBPs are required to identify and verify their customer’s identity and understand the nature of their business, ownership and control structure. This requires carrying out appropriate CDD measures as required under the interpretive note to R.10, para. 5(b)(ii). The obligation to understand their customer and their risk profile should be ongoing, and countries should ensure that the information collected in the context of CDD is adequate, accurate and up to date.",
              "children": []
            },
            {
              "id": "clause-161-25-consistent-bo-heading",
              "type": "inlineHeading",
              "text": "Consistent application of the beneficial ownership definition for trusts and similar legal arrangements"
            },
            {
              "id": "clause-162-26",
              "type": "clause",
              "marker": "162.",
              "level": "main",
              "text": "The revised FATF Recommendations include a definition of beneficial ownership in the context of trusts and similar legal arrangements covering holders of object of a power in that trust or similar arrangement. All FIs and DNFBPs applying the CDD obligation of identifying and verifying the identity of beneficial owners of trusts and similar arrangements, shall identify and verify all parties as listed under the glossary definition of beneficial owner and in accordance with INR.25.1.",
              "children": []
            },
            {
              "id": "clause-162-26-application-identification-heading",
              "type": "inlineHeading",
              "text": "Application of identification and verification measures where parties to the trust and similar legal arrangement are legal persons or arrangements."
            },
            {
              "id": "clause-163-27",
              "type": "clause",
              "marker": "163.",
              "level": "main",
              "text": "In the case of trusts and similar legal arrangements, it may be the case that some of the parties involved in the trust are legal persons or arrangements. By way of examples, the trustee administering the trust may be a commercial entity providing trust services, the settlor may be an enterprise setting up a trust fund for the benefit of its employees or a legal entity may act as nominee for an individual settlor or on the instructions of an individual who has provided funds to the legal entity for this purpose. In such cases, the trustee (or equivalent), and other FIs or DNFBPs providing services to such trusts or legal arrangements should identify and verify the identity of the legal person or arrangement involved in such a trust as well as its beneficial owners. Even though this requirement is only explicitly spelt out under the INR.25 (applicable to trustees), it is likewise applicable in the context of R.10 and R.22 when all other FIs and DNFBPs are identifying the beneficial owners of trusts and other legal arrangements.",
              "children": []
            },
            {
              "id": "clause-164-28",
              "type": "clause",
              "marker": "164.",
              "level": "main",
              "text": "Trustees, other FIs and DNFBPs should identify and verify parties to trusts and similar legal arrangements, that are legal persons or arrangements, by collecting and verifying their basic and beneficial ownership information in line with R.10.",
              "children": []
            },
            {
              "id": "clause-164-28-objects-of-power-heading",
              "type": "inlineHeading",
              "text": "Applying identification and verification requirements in respect of objects of a power"
            },
            {
              "id": "clause-165-29",
              "type": "clause",
              "marker": "165.",
              "level": "main",
              "text": "Where a FI or DNFBP other than the trustee is providing services to an express trust or legal arrangement, in determining who the beneficial owner is, the FI or DNFBP should determine the role/status that such a beneficial owner has within the legal arrangement (i.e., whether they are a settlor, trustee, beneficiary or object of a power). To comply with R.10, FI or DNFBP may rely on the trustee (who is obliged to disclose their status to FI or DNFBPs) to indicate or declare whether there is any object of a power in respect of that trust and indicate who that person is, given that it is only the trustee who would be able to determine that. However, in line with INR.10 this information should satisfy the FI/DNFBP that it is able to establish the beneficiary’s identity at the time of the payout or when the beneficiary intends to exercise vested rights.",
              "children": []
            },
            {
              "id": "clause-166-30",
              "type": "clause",
              "marker": "166.",
              "level": "main",
              "text": "With respect to persons who are the object of a power it is not mandatory to obtain official documentation (such as identity documentation or passports) to verify one’s identity as the object of a power might not be yet aware of the existence of the trust itself. Verification measures that can be deployed on a risk sensitive basis include:",
              "children": []
            },
            {
              "id": "clause-167-31",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "obtaining a declaration confirming the identification details of the object of a power from the settlor (in the case of trustees) or the trustee (in case of FIs or DNFBPs).",
              "children": []
            },
            {
              "id": "clause-168-32",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "relying on any identification details that might be available in a trust deed, letter of wishes or similar document.",
              "children": []
            },
            {
              "id": "clause-169-33",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "verifying the information from publicly available sources or accessible registries.",
              "children": []
            },
            {
              "id": "clause-170-34",
              "type": "clause",
              "marker": "•",
              "level": "nested",
              "text": "obtaining official documentation or delaying this until the time of pay out.",
              "children": []
            },
            {
              "id": "paragraph--35",
              "type": "inlineHeading",
              "text": "Holding basic information on regulated agents and service providers to the trust or similar legal arrangement"
            },
            {
              "id": "clause-167-36",
              "type": "clause",
              "marker": "167.",
              "level": "main",
              "text": "Countries should require trustees (or similar function holders in other arrangements) that reside or are administering trusts or similar legal arrangements in that country to identify agents and service providers of the trust or similar legal arrangements. This would include service providers such as investment advisors, accountants, lawyers, or tax advisors. The INR.25 stipulates that trustees should collect “basic information” on such agents and service providers.",
              "children": []
            },
            {
              "id": "clause-168-37",
              "type": "clause",
              "marker": "168.",
              "level": "main",
              "text": "It should also be clarified that this obligation is envisaged only by R.25 and hence applicable only to trustees. It does not apply to other FIs and DNFBPs – other than when these act as service providers - who may be servicing the trust (e.g., a bank providing a bank account) since it is not possible or expected for such FIs or DNFBPs to know about other service providers that are servicing the trust or legal arrangement.",
              "children": []
            },
            {
              "id": "clause-168-37-acting-on-behalf-heading",
              "type": "inlineHeading",
              "text": "Identifying persons that are acting on behalf of a trust or similar legal arrangements"
            },
            {
              "id": "clause-169-38",
              "type": "clause",
              "marker": "169.",
              "level": "main",
              "text": "R.25 requires trustees and persons holding equivalent functions in other legal arrangements to disclose their status when entering a business relationship or carrying out an occasional transaction with an FI or DNFBP.",
              "children": []
            },
            {
              "id": "clause-170-39",
              "type": "clause",
              "marker": "170.",
              "level": "main",
              "text": "FIs and DNFBPs may rely on trustees (and equivalent function holders) to disclose their status when entering a business relationship or carrying out an occasional transaction on behalf of a trust. FIs and DNFBPs should, however, be aware of certain circumstances that may indicate that a person is not legitimately acting in their declared role but instead is acting on behalf of another natural person, legal person or arrangement without disclosing this. Such indicators could include:",
              "children": []
            },
            {
              "id": "clause-170-39-indicator-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "situations where the declared trustee is unable to give immediate directions and asks to be allowed time to do so.",
              "children": []
            },
            {
              "id": "clause-170-39-indicator-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "the funding or the assets held by the FI/DNFBP originate from a source other than the declared trustee.",
              "children": []
            },
            {
              "id": "clause-170-39-indicator-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "doubts exist about the disclosed purpose of the business relationship or rationale of certain transactions.",
              "children": []
            },
            {
              "id": "clause-170-39-indicator-3",
              "type": "clause",
              "marker": "d.",
              "level": "nested",
              "text": "situations where transactions do not align with the disclosed purpose of the business relationship (e.g., destination of funds is inconsistent with the disclosed purpose).",
              "children": []
            },
            {
              "id": "paragraph--40",
              "type": "inlineHeading",
              "text": "Wire transfers and beneficial ownership as part of CDD"
            },
            {
              "id": "clause-171-41",
              "type": "clause",
              "marker": "171.",
              "level": "main",
              "text": "In relation to wire transfers (R.16), FIs should be required to undertake CDD measures as set out in R.10 when carrying out occasional transactions in the circumstances covered by R.16 and its Interpretive Note. This includes the requirement to identify and take reasonable measures to verify the identity of the beneficial owner of the originator or beneficiary when it is a legal arrangement. In addition, R.16 requires FIs to take further measures such as collecting certain originator information and ensuring that this information accompanies a wire transfer. 35",
              "children": []
            },
            {
              "id": "clause-171-41-fatf-rba-guidance-heading",
              "type": "inlineHeading",
              "text": "FATF RBA Guidance"
            },
            {
              "id": "clause-172-42",
              "type": "clause",
              "marker": "172.",
              "level": "main",
              "text": "The risk-based approach is central to the effective implementation of the FATF Recommendation. It means that supervisors, FIs, and DNFBPs should identify, assess, and understand the ML/TF risks to which they are exposed, and implement the most appropriate mitigation measures.",
              "children": []
            },
            {
              "id": "clause-173-43",
              "type": "clause",
              "marker": "173.",
              "level": "main",
              "text": "The FATF RBA Guidance provides specific guidance for various sectors and their supervisors. The Guidance also highlights the importance of supervising beneficial ownership requirements and nominee arrangements. For example, it underscores how supervisory frameworks can help determine whether adequate, accurate and up-to-date beneficial ownership information on legal persons and legal arrangements is maintained.",
              "children": []
            },
            {
              "id": "clause-174-44",
              "type": "clause",
              "marker": "174.",
              "level": "main",
              "text": "This is particularly true for TCSPs, lawyers and accountants and, as a result, FATF Guidance to these sectors should also be considered when applying the requirements of R.25. 36",
              "children": []
            }
          ]
        },
        {
          "number": "8",
          "label": "Section 8",
          "title": "International co-operation",
          "hideLabel": false,
          "body": "",
          "blocks": [
            {
              "id": "clause-175-0",
              "type": "clause",
              "marker": "175.",
              "level": "main",
              "text": "Express trusts and other similar legal arrangements may be used in cross- jurisdictional ML/TF. Effective international co-operation, as set out in FATF R.37 and R.40, requires access, through the full co-operation of jurisdictional authorities, to accurate information on beneficial owners in the context of an international ML/TF investigation. Countries should be able to obtain information, including beneficial ownership information, on express trusts and other similar legal arrangements from other countries. In turn, those countries need to respond to requests from foreign counterparts for information, including beneficial ownership information on express trusts and other similar legal arrangements that may be domestically available.",
              "children": []
            },
            {
              "id": "clause-176-1",
              "type": "clause",
              "marker": "176.",
              "level": "main",
              "text": "To ensure that there is a practical level of international co-operation in relation to information on express trusts and other similar legal arrangements, R.25 contains specific requirements to provide international co-operation, including:",
              "children": []
            },
            {
              "id": "clause-176-1-cooperation-0",
              "type": "clause",
              "marker": "a.",
              "level": "nested",
              "text": "facilitating access by foreign competent authorities to any information held by registries or other domestic authorities (e.g., by having an efficient mechanism through which foreign authorities can request information);",
              "children": []
            },
            {
              "id": "clause-176-1-cooperation-1",
              "type": "clause",
              "marker": "b.",
              "level": "nested",
              "text": "exchanging available information on express trusts or other legal arrangements to enable foreign authorities to quickly move along a chain of legal ownership; and",
              "children": []
            },
            {
              "id": "clause-176-1-cooperation-2",
              "type": "clause",
              "marker": "c.",
              "level": "nested",
              "text": "using their competent authorities’ powers, in accordance with domestic law, to obtain beneficial ownership information on behalf of foreign counterparts (e.g., at the request of foreign competent authorities, not only when conducting their own investigations).",
              "children": []
            },
            {
              "id": "clause-177-2",
              "type": "clause",
              "marker": "177.",
              "level": "main",
              "text": "The exchange of information with a foreign counterpart should avoid unduly restrictive conditions for accessing information, subject to internationally agreed standards. What could be considered as “unduly restrictive conditions on the exchange of information or assistance” may include, inter alia, the refusal of requests for assistance on the grounds that they involve fiscal, including tax, 37 matters, or on the grounds of bank secrecy.",
              "children": []
            },
            {
              "id": "clause-178-3",
              "type": "clause",
              "marker": "178.",
              "level": "main",
              "text": "Countries may consider making information on the point(s) of contact, agency, or registry information (as applicable) and the procedure for accessing or requesting this information, publicly available (e.g., online) or through specific posted guidance on procedures, to assist foreign counterparts with requesting assistance or co- operation.",
              "children": []
            },
            {
              "id": "clause-179-4",
              "type": "clause",
              "marker": "179.",
              "level": "main",
              "text": "Countries with express trusts and other similar legal arrangements governed under their law should have mechanisms in place to identify and describe the different types, forms, and basic features of express trusts and/or other similar legal arrangements in the country, and to identify and describe the processes for setting up those legal arrangements and obtaining beneficial ownership information. In addition, information on such mechanisms should be made publicly available.",
              "children": []
            },
            {
              "id": "clause-180-5",
              "type": "clause",
              "marker": "180.",
              "level": "main",
              "text": "To facilitate the efficient and rapid exchange of beneficial ownership information across jurisdictions, countries may consider publicising instructions on how to make a formal request for such information, such as through mutual legal assistance, and should make contact information for receiving and responding to requests publicly available. Countries should designate the appropriate agency(ies) (e.g., ministries or agencies with registry jurisdiction) responsible for receiving and processing foreign requests for beneficial ownership information and provide clear guidance to foreign counterparts on the process for requesting information with clear requirements, as well as any restrictions, for the requested information. Countries may also consider having in place an adequate internal procedure for interagency co- operation amongst relevant competent authorities in processing such requests. A defined, reasonable response time should be transparently reflected in the procedure.",
              "children": []
            },
            {
              "id": "subheading-annex-a-trust-purposes-6",
              "type": "subheading",
              "text": "8.1 Annex A. Trust Purposes",
              "subsectionIndex": 0
            },
            {
              "id": "annex-a-paragraph-0",
              "type": "paragraph",
              "text": "The list of purposes included in this Annex is not exhaustive, and some might be considered illegal under domestic law."
            },
            {
              "id": "annex-a-inlineHeading-1",
              "type": "inlineHeading",
              "text": "Asset protection"
            },
            {
              "id": "annex-a-paragraph-2",
              "type": "paragraph",
              "text": "Trusts are regularly used to preserve assets from perceived external risk, for example:"
            },
            {
              "id": "annex-a-clause-3",
              "type": "clause",
              "text": "Divorce actions.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-4",
              "type": "clause",
              "text": "Claims by creditors or risk of bankruptcy.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-5",
              "type": "clause",
              "text": "Forced heirship provisions.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-6",
              "type": "clause",
              "text": "Concerns about political uncertainty.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-inlineHeading-7",
              "type": "inlineHeading",
              "text": "Asset management"
            },
            {
              "id": "annex-a-paragraph-8",
              "type": "paragraph",
              "text": "The ability to hold assets with, and have those assets managed by, a trusted decision maker for the trust beneficiaries is central to the use of many trusts. Examples include where:"
            },
            {
              "id": "annex-a-clause-9",
              "type": "clause",
              "text": "There is concern about the beneficiary’s current future or capacity, understanding and responsibility to own the assets outright (e.g., the person is a minor or wants to ensure responsible management as the person ages and risks becoming incapacitated).",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-10",
              "type": "clause",
              "text": "The beneficiary suffers from a mental incapacity or severe disability that prevents them from managing their affairs.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-11",
              "type": "clause",
              "text": "The beneficiary is considered impressionable (e.g., when the person is easy to influence because of his/her young age).",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-12",
              "type": "clause",
              "text": "Regulation prevents the beneficiary from owning the asset.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-13",
              "type": "clause",
              "text": "Independent oversight of assets is required.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-14",
              "type": "clause",
              "text": "To set up 'spendthrift trusts' (where the beneficiary has limited access to assets).",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-15",
              "type": "clause",
              "text": "To prevent a beneficiary from obligating trusts’ assets for debt obligations.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-16",
              "type": "clause",
              "text": "To ensure business continuity.",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-paragraph-17",
              "type": "paragraph",
              "text": "From an operational perspective, trusts may be used to separate the management of the business from the enjoyment of the underlying proceeds and prevent fragmentation or dilution of ownership."
            },
            {
              "id": "annex-a-paragraph-18",
              "type": "paragraph",
              "text": "The continuity of management may help to ensure that the assets are not prone to short-term views and may reduce the potential disruptions to an asset owned by the trust (such as commercial real estate or a closely held business) that might otherwise stem from individual ownership, helping to ensure stability for all beneficiaries and for the asset or business itself. With ownership being held in trust, those beneficiaries who are less directly involved in the day-to-day activities may be given a share in the value of the business, and may benefit from an income stream, without acquiring the control that comes with outright ownership."
            },
            {
              "id": "annex-a-inlineHeading-19",
              "type": "inlineHeading",
              "text": "Privacy"
            },
            {
              "id": "annex-a-paragraph-20",
              "type": "paragraph",
              "text": "Trusts provide a layer of privacy. This may be considered important for cases such as the security and safety of high-profile individuals or managing expectations of beneficiaries (for example, to reduce the risk of providing a disincentive for a beneficiary to develop their own skills and self-sufficiency)."
            },
            {
              "id": "annex-a-inlineHeading-21",
              "type": "inlineHeading",
              "text": "Overcoming legal obstacles"
            },
            {
              "id": "annex-a-paragraph-22",
              "type": "paragraph",
              "text": "Some jurisdictions impose limits on who can own assets. For example, you may need to be a resident of the country to own real property there. Appointing a resident trustee to own the asset on your behalf (or on behalf of a number of entities) overcome such rules."
            },
            {
              "id": "annex-a-inlineHeading-23",
              "type": "inlineHeading",
              "text": "Tax optimisation"
            },
            {
              "id": "annex-a-paragraph-24",
              "type": "paragraph",
              "text": "In some countries, trusts may be exempt from income tax and other types of tax or may be taxed at a lower rate compared to companies or the tax rate imposed on beneficiaries in a country in which the beneficiary would be subject to taxation. (However, in some jurisdictions, trusts are taxed at a significantly higher effective rate than individual beneficiaries.)"
            },
            {
              "id": "annex-a-paragraph-25",
              "type": "paragraph",
              "text": "Identifying the trustees in a jurisdiction where the trustees are tax-exempt avoids the potential for double taxation or a lack of proper reliefs between the countries. This, and the ability to make appointments to beneficiaries at the time of the trustees’ choosing, can delay the time when taxation arises on a beneficiary."
            },
            {
              "id": "annex-a-inlineHeading-26",
              "type": "inlineHeading",
              "text": "Estate planning and succession"
            },
            {
              "id": "annex-a-paragraph-27",
              "type": "paragraph",
              "text": "Trusts may be useful in the context of estate planning as they provide continuity of management and administration of interests in property, as well as the ability to create and protect future interests in property for people who are not presently ascertainable (such as unborn descendants of the trust’s grantor). In addition, this continuity of management is important during the grantor’s life, thereby avoiding the difficulties of managing the property of an incapacitated adult under a power of attorney that often is not recognised by financial institutions or others."
            },
            {
              "id": "annex-a-paragraph-28",
              "type": "paragraph",
              "text": "Trusts may also play a role in avoiding succession delays, costs and formalities that would otherwise arise on the death of a testator who owns the assets in his or her sole name personally. As legal title to the trust assets is held by the trustee, there is continuity of ownership which is unaffected by the death of the settlor (or a beneficiary). This may avoid practical issues and delays such as where a bank account would otherwise be “frozen” pending the grant of succession; or where assets are owned in different countries."
            },
            {
              "id": "annex-a-inlineHeading-29",
              "type": "inlineHeading",
              "text": "Investment or commercial holding vehicle"
            },
            {
              "id": "annex-a-paragraph-30",
              "type": "paragraph",
              "text": "Trusts may be used as a holding vehicle for joint investments, such as unit trust type arrangements and pension funds."
            },
            {
              "id": "annex-a-paragraph-31",
              "type": "paragraph",
              "text": "Trusts can be used for conducting certain commercial operations, such as to:"
            },
            {
              "id": "annex-a-clause-32",
              "type": "clause",
              "text": "Ring-fence funds to ensure consumer protection (e.g., landlords holding tenants’ deposits or travel companies holding funds provided for holidays).",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-33",
              "type": "clause",
              "text": "Ring-fence funds for employees (e.g., group life policies that provide lump sum death benefits).",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-34",
              "type": "clause",
              "text": "Fulfil a future obligation (e.g., the provision of funeral services or building maintenance services; or in relation to the future decommissioning of oil fields).",
              "marker": "•",
              "level": "main",
              "children": []
            },
            {
              "id": "annex-a-clause-35",
              "type": "clause",
              "text": "Provide security for contracts (e.g., amounts of additional contingent consideration on the sale of shares or assets; or in relation to financial market bond issues).",
              "marker": "•",
              "level": "main",
              "children": []
            }
          ]
        }
      ]
    }
  ]
};

export default fatfBeneficialOwnership_2024;
